<template>
    <v-layout row class="bg-white">
        <!-- <v-main class="primary"> -->
        <link rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
        <!-- tela inicial -->
        <v-container grid-list-xl fluid>

            <v-layout row>
                <HelperMedico :lista-help="listaHelp" :dialog-help="dialogHelp" :descricao-dialogo="''"
                    @alterar-dialog-help="alterarDialogHelp" />
            </v-layout>
            <div v-if="iniciouAtendimento && !user.tecnico" class="animated fadeInUp">
                <prontuario :socket="socket" v-if="ficha.idAtendimento" v-on:solicitacao="addSolicitacao"
                    v-on:conteudoProntuario="addProntuario" v-on:conteudoLaudo="addLaudo" :tempoAtd="tempoAtendimento"
                    :mFicha="ficha" :consultasPaciente="listaConsultasPaciente"
                    @encerrarAtd="retornarConsultasPaciente(1)" @dadosProntuario="carregarDadosProntuario()" @addVoltar="addVoltar()"
                    @addListaDeEspera="atendimentoEmEspera()"></prontuario>
            </div>

            <!-- Configuração do médico-->
            <div v-if="!mostrarTelaPrincipal && !ficha.codigo" row
                :class="!mostrarTelaPrincipal && !ficha.codigo ? 'animated fadeInDown pa-5' : 'animated fadeInUp pa-5'">
                <v-card class="rounded-xl px-2" color="grey lighten-5">
                    <br>
                    <v-card-title primary-title class="grey--text text--darken-2 pt-0 justify-center">
                        <div>
                            <div v-if="user.tecnico">
                                <v-layout row justify-center class="mensagemInicial">
                                    Olá,&ensp; <div class="primary--text"> {{ nomeFormatado(user.nome) }} </div>.
                                </v-layout>
                            </div>
                            <div v-else>
                                <v-layout row justify-center class="mensagemInicial">
                                    Olá, Dr(a).&ensp;<div class="primary--text"> {{ nomeFormatado(user.nome) }}
                                    </div>.
                                </v-layout>
                            </div>
                            <div class="mensagemInicial">
                                Preencha os campos abaixo de acordo com seu local de atendimento.
                            </div>
                        </div>
                    </v-card-title>
                    <template v-if="!addNew">
                        <v-card flat class="rounded-xl px-2 py-2 mb-2">
                            <v-list subheader two-line>
                                <v-toolbar color="light-blue darken-2" dark>
                                    <v-toolbar-title>Configurações</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                  <!-- Exibir v-alert caso a lista esteja vazia -->
                                        <v-alert
                                            v-if="listaDeCredenciais.length === 0"
                                            type="info"
                                            color="orange"
                                            text
                                            class="mt-4"
                                        >
                                            Nenhum item disponível na lista de credenciais.
                                        </v-alert>
                                <v-list-item v-for="(item, index) in listaDeCredenciais" :key="index"
                                    @click="selectedCard = item._id,
                                     addNew = false,
                                     agruparLocaisPorUnidade(item.unidade),
                                     agruparServicosPorLocal(item.local),
                                     item.servicos = listaServicos
                                     " :class="{
                                        'selected-card': selectedCard === item._id,
                                    }">
                                    <v-list-item-avatar>
                                        <v-icon color="light-blue">mdi-folder</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Usuário: {{ item.idUsuario }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="listaServicos.length == 0">
                                            Unidade: {{ item.unidade.nomeUnidade }}<br />
                                            Local: {{ item.local.nomeLocal }}<br />
                                            Serviços:
                                            <span v-for="servico in item.servicos" :key="servico.idServico">
                                                {{ servico.nomeEspecialidade }}
                                            </span>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle v-else>
                                            Unidade: {{ item.unidade.nomeUnidade }}<br />
                                            Local: {{ item.local.nomeLocal }}<br />
                                            Serviços:
                                            <span v-for="servico in listaServicos" :key="servico.idServico">
                                                {{ servico.nomeEspecialidade }}<span
                                                    v-if="!isLastService(item.servicos, servico)">, </span>
                                            </span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-btn icon>
                                            <v-icon :color="selectedCard === item._id ? 'green' : 'grey'">
                                                mdi-check-circle
                                            </v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                            <v-card-actions>
                                <!-- Botão Excluir -->
                                <v-btn color="red" text class="mt-3" :disabled="!selectedCard" @click="confirmDelete">
                                    <v-icon left>mdi-delete</v-icon>
                                    {{ deleteConfirmed ? "Confirmar Exclusão" : "Excluir" }}
                                </v-btn>

                                <v-btn
                                    color="primary"
                                    text
                                    class="mt-3"
                                    @click="addNew = true"
                                >
                                    <v-icon left>mdi-plus</v-icon>
                                    Adicionar Novo
                                </v-btn>

                                <v-spacer />

                                <!-- Botão Editar -->
                                <v-btn color="orange" text class="mt-3" :disabled="!selectedCard"
                                    @click="editSelection">
                                    <v-icon left>mdi-pencil</v-icon>
                                    Editar
                                </v-btn>

                                <!-- Botão Confirmar Seleção -->
                                <v-btn color="blue" class="mt-3" dark :disabled="!selectedCard"
                                    @click="confirmSelection">
                                    <v-icon left>mdi-check-circle</v-icon>
                                    Iniciar Atendimento
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </template>
                    <v-form ref="form" class="px-2" v-model="valid" lazy-validation v-show="addNew">
                        <v-autocomplete rounded solo v-model="unidadeSelecionada" label="Unidade" :items="listaUnidades"
                            item-value="idUnidade" return-object
                            :rules="[v => !!v || 'Escolha a unidade de atendimento']" item-text="nomeUnidade"
                            no-data-text="Nenhuma Unidade disponível" required
                            @input="agruparLocaisPorUnidade(unidadeSelecionada)" />
                        <v-autocomplete rounded solo v-model="localEscolhido" label="Local de Atendimento"
                            :items="listaLocais" return-object item-value="idLocal"
                            :rules="[v => !!v || 'Local obrigatório']" item-text="nomeLocal"
                            no-data-text="Nenhum Local disponível" required
                            @input="agruparServicosPorLocal(localEscolhido)" />
                        <v-autocomplete rounded solo v-model="listaServicosSelecionados" label="Serviços"
                            :items="listaServicos" item-value="idServico" return-object
                            :rules="[v => v && v.length > 0 || 'Escolha os serviço da para seu atendimento']"
                            item-text="nomeEspecialidade" no-data-text="Nenhum Serviço disponível" required multiple />

                        <v-layout wrap align-center>
                            <v-flex xs12 sm3>
                                <v-select rounded solo v-model="descricaoLocal" :items="itensDescricaoLocal"
                                    item-text="descricao" item-value="descricao" label="Selecione o Local" return-object
                                    single-line @input="validateField" />
                            </v-flex>
                            <v-flex xs12 sm9>
                                <v-text-field rounded solo v-model="nomeConsultorio" class="pl-3" :rules="rulesLocal"
                                    label="Número" />
                            </v-flex>
                        </v-layout>
                        <v-card-actions>
                            <v-btn
                                    color="orange"
                                    outlined
                                    large
                                    rounded
                                    @click="addNew = false"
                                >
                                    <v-icon left>keyboard_return</v-icon>
                                    Voltar
                                </v-btn>
                            <v-btn outlined dark :loading="load" large rounded color="blue" :disabled="!valid"
                                @click="cadastrarCredenciaisAtendimento()">
                                Salvar configuração
                                <v-icon right>save</v-icon>
                            </v-btn>
                            <v-spacer />

                            <v-btn :loading="load" large rounded color="primary" :disabled="!valid"
                                @click="adicionarServicosParaAtendimento()">
                                Iniciar Atendimentos
                            </v-btn>

                        </v-card-actions>

                    </v-form>
                    <br>
                </v-card>

            </div>

            <!-- tela Principal -->

            <div class="animated fadeInDown"
                v-if="(mostrarTelaPrincipal && user.tecnico) || (mostrarTelaPrincipal && !user.tecnico && !iniciouAtendimento)">
                <v-container grid-list-xl fluid>
                    <v-layout justify-center row wrap>
                        <v-flex xs8 sm8 md8>
                            <v-flex xs12 sm12 md12>
                                <v-card class="rounded-xl pb-4 px-1">
                                    <v-card-title class="text-center justify-center ">
                                        <h2 class="font-weight-bold basil--text">
                                            Pacientes
                                        </h2>
                                    </v-card-title>
                                    <v-tabs background-color="transparent" grow :loading="loadAtendidos">
                                        <v-tab :disabled="fezChamada || isAtendimento" @click="changeColor(0)">
                                            <v-badge :dot="listaPacientesDisponiveis.length <= 0"
                                                :color="listaPacientesDisponiveis.length <= 0 ? 'grey lighten-3' : 'primary'"
                                                :content="listaPacientesDisponiveis.length">
                                                Disponiveis
                                            </v-badge>

                                        </v-tab>

                                        <v-tab :disabled="fezChamada || isAtendimento" @click="changeColor(1)">
                                            <v-badge :dot="listaPacientesPendente.length <= 0"
                                                :color="listaPacientesPendente.length <= 0 ? 'grey lighten-3' : 'primary'"
                                                :content="listaPacientesPendente.length">
                                                Pendentes
                                            </v-badge>
                                        </v-tab>

                                        <v-tab :disabled="fezChamada || isAtendimento" @click="changeColor(2)">
                                            <v-badge :dot="listaPacientesEspera.length <= 0"
                                                :color="listaPacientesEspera.length <= 0 ? 'grey lighten-3' : 'primary'"
                                                :content="listaPacientesEspera.length">
                                                Em espera
                                            </v-badge>
                                        </v-tab>
                                        <v-tab :disabled="fezChamada || isAtendimento"
                                            @click="changeColor(2)">
                                            <v-badge :dot="listaPacientesAtendidos.length <= 0"
                                                :color="listaPacientesAtendidos.length <= 0 ? 'grey lighten-3' : 'green'"
                                                :content="listaPacientesAtendidos.length">
                                                Atendidos
                                            </v-badge>
                                        </v-tab>

                                        <v-tab-item>
                                            <v-card class="mt-2" flat v-if="listaPacientesDisponiveis.length >= 0">
                                                <div v-show="!ficha.codigo && listaPacientesDisponiveis.length > 0">
                                                    <v-text-field v-show="listaPacientesDisponiveis.length"
                                                        v-model="searchDisponiveis" dense outlined
                                                        class="pt-1 mx-3 mb-0 pb-0" prepend-inner-icon="search"
                                                        @click:clear="clearSearch" />
                                                    <v-list v-show="!ficha.codigo" :dense="true" class="scroll-y pt-0"
                                                        style="" two-line>
                                                        <v-virtual-scroll :bench="0"
                                                            :items="listaPacientesDisponiveisFiltrada" height="278"
                                                            item-height="64">
                                                            <template v-slot:default="{ item }">
                                                                <v-list-item two-line :key="item.title" ripple
                                                                    @click="toggle(index)" class="animated fadeIn">
                                                                    <v-list-item-avatar>
                                                                        <v-icon
                                                                            :color="(item.prioridade == 1 || item.prioridade == 3) ? 'info' : 'grey darken-1'"
                                                                            v-text="(item.prioridade == 1 || item.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content @click="addFicha(item)">
                                                                        <v-list-item-title>
                                                                            <p class="text-sm-left font-weight-bold">
                                                                                {{ item.nomePaciente }}
                                                                            </p>
                                                                        </v-list-item-title>
                                                                        <v-list-item-subtitle>
                                                                            {{ item.nomeExame }} -
                                                                            {{ item.nomeEspecialidade }}
                                                                        </v-list-item-subtitle>

                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        <v-layout row justify-end>
                                                                            <v-chip class="mr-2" outlined
                                                                                text-color="black">
                                                                                {{
                                                                                    calcularIdade(item.dataNascimento).idade
                                                                                }} anos
                                                                                <v-img class="ml-1"
                                                                                    src="../assets/age-group_3787841.png"
                                                                                    max-height="26"
                                                                                    max-width="26"></v-img>
                                                                                <!-- mdi-cake-variant -->
                                                                            </v-chip>
                                                                            <v-chip outlined
                                                                                v-show="calcularIdade(item.dataNascimento).fazAniversarioNoMesAtual">
                                                                                <v-icon left color="blue">
                                                                                    calendar_month
                                                                                </v-icon>
                                                                                <strong>{{
                                                                                    calcularIdade(item.dataNascimento).diaAniversario
                                                                                    }}</strong>
                                                                                <v-icon right color="pink">
                                                                                    mdi-cake-variant
                                                                                </v-icon>

                                                                            </v-chip>
                                                                        </v-layout>
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-divider />
                                                            </template>
                                                        </v-virtual-scroll>
                                                    </v-list>
                                                </div>
                                                <div v-show="ficha.codigo" class="animated fadeIn">
                                                    <v-container grid-list-xl fluid>
                                                        <v-layout row wrap class="align-center justify-center">
                                                            <div class="display-2">
                                                                {{ tempoAtendimento }}
                                                            </div>
                                                        </v-layout>
                                                        <v-card outlined>
                                                            <v-list :dense="true">
                                                                <v-list-item two-line :key="ficha.codigo" ripple>
                                                                    <v-list-item-avatar>
                                                                        <v-icon
                                                                            :color="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'info' : 'grey darken-1'"
                                                                            v-text="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <p class="text-sm-left font-weight-bold">
                                                                                {{ ficha.nomePaciente }}
                                                                            </p>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        <v-layout row justify-end>
                                                                            <v-chip class="mr-2" outlined
                                                                                text-color="black">
                                                                                {{
                                                                                    calcularIdade(ficha.dataNascimento).idade
                                                                                }} anos
                                                                                <v-img class="ml-1"
                                                                                    src="../assets/age-group_3787841.png"
                                                                                    max-height="26"
                                                                                    max-width="26"></v-img>
                                                                                <!-- mdi-cake-variant -->
                                                                            </v-chip>
                                                                            <v-chip outlined
                                                                                v-show="calcularIdade(ficha.dataNascimento).fazAniversarioNoMesAtual">
                                                                                <v-icon left color="blue">
                                                                                    calendar_month
                                                                                </v-icon>
                                                                                <strong>{{
                                                                                    calcularIdade(ficha.dataNascimento).diaAniversario
                                                                                    }}</strong>
                                                                                <v-icon right color="pink">
                                                                                    mdi-cake-variant
                                                                                </v-icon>

                                                                            </v-chip>
                                                                        </v-layout>
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-card>
                                                        <v-card class="mt-2" outlined>
                                                            <v-card-text>
                                                                <h3>
                                                                    <v-layout row justify-center align-center>
                                                                        Exame(s):
                                                                        <div class="pl-2">
                                                                            {{ ficha.nomeExame }}
                                                                        </div>

                                                                        <v-btn v-show="listaConsultasPaciente.length"
                                                                            icon small @click="show = !show">
                                                                            + {{ listaConsultasPaciente.length - 1
                                                                            }}
                                                                        </v-btn>
                                                                    </v-layout>
                                                                </h3>

                                                                <div v-show="show" class="animated fadeInDown">
                                                                    <!-- <v-divider /> -->
                                                                    <v-card-text>
                                                                        <div v-for="(consulta, index) in listaConsultasPaciente"
                                                                            :key="index">
                                                                            <div
                                                                                v-show="ficha.idExame !== consulta.idExame">
                                                                                <strong :class="consulta.colorText">
                                                                                    {{ consulta.nomeExame }}
                                                                                </strong>
                                                                                <v-divider
                                                                                    v-if="index + 1 < listaConsultasPaciente.length"
                                                                                    :key="index" />
                                                                            </div>
                                                                        </div>
                                                                    </v-card-text>
                                                                </div>

                                                                <div justify-end>
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on }">
                                                                            <button
                                                                                @click="onCopy(ficha.idOrdemServico)"
                                                                                type="button" v-on="on">
                                                                                Copiar O.S!
                                                                            </button>

                                                                        </template>
                                                                        <span>{{ textClipBoard }}</span>
                                                                    </v-tooltip>
                                                                </div>
                                                                <strong>OS: {{ ficha.idOrdemServico }}</strong>
                                                            </v-card-text>
                                                            <v-divider />
                                                            <v-card-actions class="text-center">
                                                                <v-btn v-show="!fezChamada || emPacientePendente"
                                                                    :disabled="isAtendimento" light text rounded
                                                                    color="" @click="voltar()">
                                                                    <v-icon left>
                                                                        keyboard_backspace
                                                                    </v-icon>voltar
                                                                </v-btn>
                                                                <v-btn
                                                                    :disabled="!ficha.nomeEspecialidade.length || desabilitaBotaoChamar"
                                                                    light outlined rounded @click="fazerChamada()">
                                                                    chamar
                                                                    <v-icon right>
                                                                        record_voice_over
                                                                    </v-icon>
                                                                </v-btn>

                                                            </v-card-actions>
                                                            <v-divider />
                                                            <v-card-actions v-if="ficha.codigo">

                                                                <v-btn v-show="!iniciouAtendimento" depressed :disabled="!fezChamada" class="white--text" rounded large color="primary" @click="iniciarAtendimento()">
                                                                    Iniciar Atendimento
                                                                </v-btn>

                                                                <v-btn :loading="loadFinalizar" v-show="iniciouAtendimento" depressed class="white--text" :disabled="!ficha.nomeEspecialidade" rounded large color="green" @click="retornarConsultasPaciente(1)" >
                                                                    <v-icon color="white">check_circle</v-icon>
                                                                    Finalizar
                                                                </v-btn>

                                                                <v-btn v-if="!isAtendimento && !isEspera" large
                                                                    outlinedd class="rounded-card white--text"
                                                                    color="red lighten-1"
                                                                    :disabled="!fezChamada || !habilitarBotaoCronometro || isAtendimento"
                                                                    @click="dialogNaoCompareceu = true">
                                                                    não compareceu {{ textCronometroRegressivo }}
                                                                </v-btn>

                                                                <v-btn v-if="isAtendimento" large depressed outlinedd class="rounded-card white--text" color="orange darken-2" @click="atendimentoEmEspera()">
                                                                    <v-icon color="white">hourglass_top</v-icon>
                                                                    Espera
                                                                </v-btn>
                                                                <!--DISPONIVEIS-->
                                                                <div v-if="isAtendimento && user.tecnico == 1" class="ml-2">
                                                                    <anamnese :ficha="ficha" />
                                                                </div>
                                                                <div v-if="isAtendimento && user.tecnico == 1" class="ml-2">
                                                                    <preLaudo :user="user" :ficha="ficha" :listaConsultasPaciente="listaConsultasPaciente" />
                                                                </div>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-container>
                                                </div>
                                            </v-card>

                                            <div v-if="listaPacientesDisponiveis.length == 0 && !ficha.codigo">
                                                <v-card flat width="434">
                                                    <div v-for="i in 6" :key="i">
                                                        <v-skeleton-loader class="mx-auto"
                                                            type="list-item-avatar-two-line" :loading="true"
                                                            title="Aguardando pacientes"></v-skeleton-loader>
                                                    </div>
                                                </v-card>
                                            </div>
                                        </v-tab-item>
                                        <!-- PENDENTES-->
                                        <v-tab-item>
                                            <v-container grid-list-xl fluid>
                                                <v-card flat v-if="listaPacientesPendente.length >= 0">
                                                    <div v-show="!ficha.codigo && listaPacientesPendente.length > 0">
                                                        <v-text-field v-show="listaPacientesPendente.length"
                                                            v-model="searchPendentes" dense outlined
                                                            class="pt-1 mx-3 mb-0 pb-0" prepend-inner-icon="search"
                                                            @click:clear="clearSearch" />
                                                        <v-list :dense="true" class="scroll-y" style="" two-line>
                                                            <v-virtual-scroll :bench="0"
                                                                :items="listaPacientesPendenteFiltrada" height="278"
                                                                item-height="64">
                                                                <template v-slot:default="{ item }">

                                                                    <v-list-item :key="item.title" avatar ripple
                                                                        @click="toggle(index)">
                                                                        <v-list-item-content @click="addFicha(item)">
                                                                            <v-list-item-title>
                                                                                <p
                                                                                    class="text-sm-left font-weight-bold">
                                                                                    {{ item.idAtendimento }} - {{
                                                                                        item.nomePaciente }}
                                                                                </p>
                                                                            </v-list-item-title>
                                                                            <v-list-item-subtitle>
                                                                                {{ item.nomeExame }} -
                                                                                {{ item.nomeEspecialidade }}
                                                                            </v-list-item-subtitle>

                                                                        </v-list-item-content>
                                                                        <v-list-item-action>
                                                                            <v-layout row justify-end>
                                                                                <v-chip class="mr-2" outlined
                                                                                    text-color="black">
                                                                                    {{
                                                                                        calcularIdade(item.dataNascimento).idade
                                                                                    }} anos
                                                                                    <v-img class="ml-1"
                                                                                        src="../assets/age-group_3787841.png"
                                                                                        max-height="26"
                                                                                        max-width="26"></v-img>
                                                                                    <!-- mdi-cake-variant -->
                                                                                </v-chip>
                                                                                <v-chip outlined
                                                                                    v-show="calcularIdade(item.dataNascimento).fazAniversarioNoMesAtual">
                                                                                    <v-icon left color="blue">
                                                                                        calendar_month
                                                                                    </v-icon>
                                                                                    <strong>{{
                                                                                        calcularIdade(item.dataNascimento).diaAniversario
                                                                                        }}</strong>
                                                                                    <v-icon right color="pink">
                                                                                        mdi-cake-variant
                                                                                    </v-icon>

                                                                                </v-chip>
                                                                            </v-layout>
                                                                        </v-list-item-action>
                                                                    </v-list-item>
                                                                    <v-divider
                                                                        v-if="index + 1 < listaPacientesPendente.length"
                                                                        :key="index" />
                                                                </template>
                                                            </v-virtual-scroll>
                                                        </v-list>
                                                    </div>
                                                    <div v-show="ficha.codigo" class="animated fadeIn">
                                                        <v-layout row class="align-center justify-center">
                                                            <div class="display-2">
                                                                {{ tempoAtendimento }}
                                                            </div>
                                                        </v-layout>
                                                        <v-card outlined>
                                                            <v-list :dense="true">
                                                                <v-list-item :key="ficha.codigo" ripple>
                                                                    <v-list-item-avatar>
                                                                        <v-icon
                                                                            :color="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'info' : 'grey darken-1'"
                                                                            v-text="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <p class="text-sm-left font-weight-bold">
                                                                                {{ ficha.nomePaciente }}
                                                                            </p>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        <v-layout row justify-end>
                                                                            <v-chip class="mr-2" outlined
                                                                                text-color="black">
                                                                                {{
                                                                                    calcularIdade(ficha.dataNascimento).idade
                                                                                }} anos
                                                                                <v-img class="ml-1"
                                                                                    src="../assets/age-group_3787841.png"
                                                                                    max-height="26"
                                                                                    max-width="26"></v-img>
                                                                                <!-- mdi-cake-variant -->
                                                                            </v-chip>
                                                                            <v-chip outlined
                                                                                v-show="calcularIdade(ficha.dataNascimento).fazAniversarioNoMesAtual">
                                                                                <v-icon left color="blue">
                                                                                    calendar_month
                                                                                </v-icon>
                                                                                <strong>{{
                                                                                    calcularIdade(ficha.dataNascimento).diaAniversario
                                                                                    }}</strong>
                                                                                <v-icon right color="pink">
                                                                                    mdi-cake-variant
                                                                                </v-icon>

                                                                            </v-chip>
                                                                        </v-layout>
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-card>
                                                        <v-card class="mt-2" outlined>
                                                            <v-card-text>
                                                                <h3>
                                                                    <v-layout row justify-center align-center>
                                                                        Exame(s):
                                                                        <div class="pl-2">
                                                                            {{ ficha.nomeExame }}
                                                                        </div>

                                                                        <v-btn v-show="listaConsultasPaciente.length"
                                                                            icon small @click="show = !show">
                                                                            + {{ listaConsultasPaciente.length - 1
                                                                            }}
                                                                        </v-btn>
                                                                    </v-layout>
                                                                </h3>

                                                                <div v-show="show" class="animated fadeInDown">
                                                                    <!-- <v-divider /> -->
                                                                    <v-card-text>
                                                                        <div v-for="(consulta, index) in listaConsultasPaciente"
                                                                            :key="index">
                                                                            <div
                                                                                v-show="ficha.idExame !== consulta.idExame">
                                                                                <strong :class="consulta.colorText">
                                                                                    {{ consulta.nomeExame }}
                                                                                </strong>
                                                                                <v-divider
                                                                                    v-if="index + 1 < listaConsultasPaciente.length"
                                                                                    :key="index" />
                                                                            </div>
                                                                        </div>
                                                                    </v-card-text>
                                                                </div>

                                                                <div justify-end>
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on }">
                                                                            <button
                                                                                @click="onCopy(ficha.idOrdemServico)"
                                                                                type="button" v-on="on">
                                                                                Copiar O.S!
                                                                            </button>

                                                                        </template>
                                                                        <span>{{ textClipBoard }}</span>
                                                                    </v-tooltip>
                                                                </div>
                                                                <strong>OS: {{ ficha.idOrdemServico }}</strong>
                                                            </v-card-text>
                                                            <v-divider />
                                                            <v-card-actions class="text-center">
                                                                <v-btn v-show="!fezChamada || emPacientePendente"
                                                                    :disabled="isAtendimento" light text rounded
                                                                    color="" @click="voltar()">
                                                                    <v-icon left>
                                                                        keyboard_backspace
                                                                    </v-icon>voltar
                                                                </v-btn>
                                                                <v-btn
                                                                    :disabled="!ficha.nomeEspecialidade.length || desabilitaBotaoChamar"
                                                                    light outlined rounded @click="fazerChamada()">
                                                                    chamar
                                                                    <v-icon right>
                                                                        record_voice_over
                                                                    </v-icon>
                                                                </v-btn>

                                                            </v-card-actions>
                                                        </v-card>
                                                        <!-- <v-divider /> -->
                                                        <v-card-actions v-if="ficha.codigo">

                                                            <v-btn v-show="isEspera && !iniciouAtendimento" depressed
                                                                class="white--text " rounded color="primary"
                                                                @click="reiniciarAtendimento()">
                                                                Continuar Atendimento

                                                            </v-btn>

                                                            <v-btn v-show="isEspera && !iniciouAtendimento" outlinedd
                                                                class="rounded-card white--text " color="quadradoB"
                                                                @click="voltar()">
                                                                Voltar
                                                            </v-btn>

                                                            <v-btn v-show="!iniciouAtendimento && !isEspera" depressed
                                                                :disabled="!fezChamada" class="white--text" rounded
                                                                large color="primary" @click="iniciarAtendimento()">
                                                                Iniciar Atendimento

                                                            </v-btn>

                                                            <v-btn :loading="loadFinalizar" v-show="iniciouAtendimento" depressed class="white--text" :disabled="!ficha.nomeEspecialidade" rounded large color="green" @click="retornarConsultasPaciente(1)" >
                                                                    <v-icon color="white">check_circle</v-icon>
                                                                    Finalizar
                                                                </v-btn>

                                                                <v-btn v-if="!isAtendimento && !isEspera" large outlinedd class="rounded-card white--text" color="red lighten-1" :disabled="!fezChamada || !habilitarBotaoCronometro || isAtendimento " @click="dialogNaoCompareceu = true">
                                                                    não compareceu {{ textCronometroRegressivo }}
                                                                </v-btn>

                                                                <v-btn v-if="isAtendimento" large depressed outlinedd class="rounded-card white--text" color="orange darken-2" @click="atendimentoEmEspera()">
                                                                    <v-icon color="white">hourglass_top</v-icon>
                                                                    Espera
                                                                </v-btn>
                                                                <!--PENDENTES-->
                                                                <div v-if="isAtendimento && user.tecnico == 1" class="ml-2">
                                                                    <anamnese :ficha="ficha" />
                                                                </div>

                                                                <div v-if="isAtendimento && user.tecnico == 1" class="ml-2">
                                                                    <preLaudo :user="user" :ficha="ficha" :listaConsultasPaciente="listaConsultasPaciente" />
                                                                </div>

                                                        </v-card-actions>
                                                    </div>
                                                </v-card>
                                                <div v-if="listaPacientesPendente.length == 0 && !ficha.codigo">
                                                    <v-card flat width="434">
                                                        <div v-for="i in 6" :key="i">
                                                            <v-skeleton-loader class="mx-auto"
                                                                type="list-item-avatar-two-line"
                                                                :loading="true"></v-skeleton-loader>
                                                        </div>
                                                    </v-card>
                                                </div>
                                            </v-container>
                                        </v-tab-item>
                                        <!-- EM ESPERA -->
                                        <v-tab-item>
                                            <v-container grid-list-xl fluid>
                                                <v-card flat v-if="listaPacientesEspera.length >= 0">
                                                    <div v-show="!ficha.codigo && listaPacientesEspera.length > 0">
                                                        <v-text-field v-show="listaPacientesEspera.length"
                                                            v-model="searchEspera" dense outlined
                                                            class="pt-1 mx-3 mb-0 pb-0" prepend-inner-icon="search"
                                                            @click:clear="clearSearch" />
                                                        <v-list :dense="true" class="scroll-y" style="" two-line>
                                                                <v-virtual-scroll :bench="0"
                                                                :items="listaPacientesEsperaFiltrada" height="278"
                                                                item-height="64">
                                                                <template v-slot:default="{ item }">

                                                                    <v-list-item :key="item.title" ripple
                                                                        @click="toggle(index)">
                                                                        <v-list-item-content
                                                                            @click="addFichaEspera(item)">
                                                                            <v-list-item-title>
                                                                                <p
                                                                                    class="text-sm-left font-weight-bold">
                                                                                    {{ item.idAtendimento }} - {{
                                                                                        item.nomePaciente }}
                                                                                </p>
                                                                            </v-list-item-title>
                                                                            <v-list-item-subtitle>{{ item.nomeExame
                                                                                }} - {{ item.nomeEspecialidade
                                                                                }}</v-list-item-subtitle>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                    <v-divider
                                                                        v-if="index + 1 < listaPacientesEspera.length"
                                                                        :key="index" />
                                                                </template>
                                                            </v-virtual-scroll>
                                                        </v-list>
                                                    </div>
                                                    <div v-show="ficha.codigo" class="animated fadeIn">
                                                        <v-layout row class="align-center justify-center">
                                                            <div class="display-2">
                                                                {{ tempoAtendimento }}
                                                            </div>
                                                        </v-layout>
                                                        <v-card outlined>
                                                            <v-list :dense="true">
                                                                <v-list-item :key="ficha.codigo" ripple>
                                                                    <v-list-item-avatar>
                                                                        <v-icon
                                                                            :color="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'info' : 'grey darken-1'"
                                                                            v-text="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <p class="text-sm-left font-weight-bold">
                                                                                {{ ficha.nomePaciente }}
                                                                            </p>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        <v-layout row justify-end>
                                                                            <v-chip class="mr-2" outlined
                                                                                text-color="black">
                                                                                {{
                                                                                    calcularIdade(ficha.dataNascimento).idade
                                                                                }} anos
                                                                                <v-img class="ml-1"
                                                                                    src="../assets/age-group_3787841.png"
                                                                                    max-height="26"
                                                                                    max-width="26"></v-img>
                                                                                <!-- mdi-cake-variant -->
                                                                            </v-chip>
                                                                            <v-chip outlined
                                                                                v-show="calcularIdade(ficha.dataNascimento).fazAniversarioNoMesAtual">
                                                                                <v-icon left color="blue">
                                                                                    calendar_month
                                                                                </v-icon>
                                                                                <strong>{{
                                                                                    calcularIdade(ficha.dataNascimento).diaAniversario
                                                                                    }}</strong>
                                                                                <v-icon right color="pink">
                                                                                    mdi-cake-variant
                                                                                </v-icon>

                                                                            </v-chip>
                                                                        </v-layout>
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-card>
                                                        <v-card class="mt-2" outlined>
                                                            <v-card-text>
                                                                <h3>
                                                                    <v-layout row justify-center align-center>
                                                                        Exame(s):
                                                                        <div class="pl-2">
                                                                            {{ ficha.nomeExame }}
                                                                        </div>

                                                                        <v-btn v-show="listaConsultasPaciente.length"
                                                                            icon small @click="show = !show">
                                                                            + {{ listaConsultasPaciente.length - 1
                                                                            }}
                                                                        </v-btn>
                                                                    </v-layout>
                                                                </h3>

                                                                <div v-show="show" class="animated fadeInDown">
                                                                    <!-- <v-divider /> -->
                                                                    <v-card-text>
                                                                        <div v-for="(consulta, index) in listaConsultasPaciente"
                                                                            :key="index">
                                                                            <div
                                                                                v-show="ficha.idExame !== consulta.idExame">
                                                                                <strong :class="consulta.colorText">
                                                                                    {{ consulta.nomeExame }}
                                                                                </strong>
                                                                                <v-divider
                                                                                    v-if="index + 1 < listaConsultasPaciente.length"
                                                                                    :key="index" />
                                                                            </div>
                                                                        </div>
                                                                    </v-card-text>
                                                                </div>

                                                                <div justify-end>
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on }">
                                                                            <button
                                                                                @click="onCopy(ficha.idOrdemServico)"
                                                                                type="button" v-on="on">
                                                                                Copiar O.S!
                                                                            </button>

                                                                        </template>
                                                                        <span>{{ textClipBoard }}</span>
                                                                    </v-tooltip>
                                                                </div>
                                                                <strong>OS: {{ ficha.idOrdemServico }}</strong>
                                                            </v-card-text>
                                                            <v-divider />

                                                            <v-card-actions v-if="ficha.codigo">
                                                                <v-btn
                                                                    :disabled="!ficha.nomeEspecialidade.length || desabilitaBotaoChamar"
                                                                    light outlined rounded @click="fazerChamada()">
                                                                    chamar
                                                                    <v-icon right>
                                                                        record_voice_over
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn v-show="isEspera && !iniciouAtendimento"
                                                                    depressed class="white--text " rounded
                                                                    color="primary" @click="reiniciarAtendimento()">
                                                                    Continuar Atendimento
                                                                </v-btn>

                                                                <v-btn v-show="isEspera && !iniciouAtendimento"
                                                                    class="rounded-card white--text " color="quadradoB"
                                                                    @click="voltar()">
                                                                    Voltar
                                                                </v-btn>

                                                                <v-btn v-show="!iniciouAtendimento && !isEspera"
                                                                    depressed :disabled="!fezChamada"
                                                                    class="white--text" rounded large color="primary"
                                                                    @click="iniciarAtendimento()">
                                                                    Iniciar Atendimento
                                                                </v-btn>

                                                                <v-btn :loading="loadFinalizar" v-show="iniciouAtendimento" depressed class="white--text" :disabled="!ficha.nomeEspecialidade" rounded large color="green" @click="retornarConsultasPaciente(1)" >
                                                                    <v-icon color="white">check_circle</v-icon>
                                                                    Finalizar
                                                                </v-btn>

                                                                <v-btn v-if="!isAtendimento && !isEspera" large outlinedd class="rounded-card white--text" color="red lighten-1" :disabled="!fezChamada || !habilitarBotaoCronometro || isAtendimento " @click="dialogNaoCompareceu = true">
                                                                    não compareceu {{ textCronometroRegressivo }}
                                                                </v-btn>

                                                                <v-btn v-if="isAtendimento" large depressed outlinedd class="rounded-card white--text" color="orange darken-2" @click="atendimentoEmEspera()">
                                                                    <v-icon color="white">hourglass_top</v-icon>
                                                                    Espera
                                                                </v-btn>

                                                                <div v-if="isAtendimento && user.tecnico == 1"
                                                                    class="ml-4">
                                                                    <!--lista de espera-->
                                                                    <anamnese :ficha="ficha" />
                                                                </div>

                                                                <div v-if="isAtendimento && user.tecnico == 1" class="ml-2">
                                                                    <preLaudo :user="user" :ficha="ficha" :listaConsultasPaciente="listaConsultasPaciente" />
                                                                </div>

                                                            </v-card-actions>
                                                        </v-card>
                                                    </div>
                                                </v-card>
                                                <div v-if="listaPacientesEspera.length == 0 && !ficha.codigo">
                                                    <v-card flat width="434">
                                                        <div v-for="i in 6" :key="i">
                                                            <v-skeleton-loader class="mx-auto"
                                                                type="list-item-avatar-two-line"
                                                                :loading="true"></v-skeleton-loader>
                                                        </div>
                                                    </v-card>
                                                </div>
                                            </v-container>
                                        </v-tab-item>
                                        <!-- ATENDIDOS -->
                                        <v-tab-item :loading="loadAtendidos">
                                            <v-container grid-list-xl fluid>
                                                <v-progress-linear
                                                    indeterminate
                                                    color="primary"
                                                    v-show="loadAtendidos"
                                                ></v-progress-linear>
                                                <v-card flat v-show="listaPacientesAtendidos.length > 0">
                                                    <div  v-show="!isAtendidos">
                                                        <v-text-field v-model="searchAtendidos" dense outlined
                                                            class="pt-1 mx-3 mb-0 pb-0" prepend-inner-icon="search"
                                                            @click:clear="clearSearch" />
                                                        <v-list :dense="true" class="scroll-y" style="" two-line>
                                                            <v-virtual-scroll :bench="0"
                                                                :items="listaPacientesAtendidosFiltrada" height="278"
                                                                item-height="64">
                                                                <template v-slot:default="{ item }">
                                                                    <v-list-item :key="item.title" ripple
                                                                        @click="toggle(index)">
                                                                        <v-list-item-content
                                                                            @click="addFichaAtendidos(item)">
                                                                            <v-list-item-title>
                                                                                <p
                                                                                    class="text-sm-left font-weight-bold">
                                                                                    {{ item.idAtendimento }} - {{
                                                                                        item.nomePaciente }}
                                                                                </p>
                                                                            </v-list-item-title>
                                                                            <v-list-item-subtitle>{{ item.nomeExame
                                                                                }}</v-list-item-subtitle>
                                                                        </v-list-item-content>
                                                                        <v-list-item-action>
                                                                            <v-layout row justify-end>
                                                                                <v-chip class="mr-2" outlined
                                                                                    text-color="black">
                                                                                    {{
                                                                                        calcularIdade(item.dataNascimento).idade
                                                                                    }} anos
                                                                                    <v-img class="ml-1"
                                                                                        src="../assets/age-group_3787841.png"
                                                                                        max-height="26"
                                                                                        max-width="26"></v-img>
                                                                                    <!-- mdi-cake-variant -->
                                                                                </v-chip>
                                                                                <v-chip outlined
                                                                                    v-show="calcularIdade(item.dataNascimento).fazAniversarioNoMesAtual">
                                                                                    <v-icon left color="blue">
                                                                                        calendar_month
                                                                                    </v-icon>
                                                                                    <strong>{{
                                                                                        calcularIdade(item.dataNascimento).diaAniversario
                                                                                        }}</strong>
                                                                                    <v-icon right color="pink">
                                                                                        mdi-cake-variant
                                                                                    </v-icon>

                                                                                </v-chip>
                                                                            </v-layout>
                                                                        </v-list-item-action>
                                                                    </v-list-item>
                                                                    <v-divider
                                                                        v-if="index + 1 < listaPacientesAtendidos.length"
                                                                        :key="index" />
                                                                </template>
                                                            </v-virtual-scroll>
                                                        </v-list>
                                                    </div>
                                                    <div v-if="ficha.codigo && !loadAtendidos" class="animated fadeIn">
                                                        <v-card outlined>
                                                            <v-list :dense="true">
                                                                <v-list-item :key="ficha.codigo" ripple>
                                                                    <v-list-item-avatar>
                                                                        <v-icon
                                                                            :color="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'info' : 'grey darken-1'"
                                                                            v-text="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <p class="text-sm-left font-weight-bold">
                                                                                {{ ficha.nomePaciente }}
                                                                            </p>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        <v-layout row justify-end>
                                                                            <v-chip class="mr-2" outlined
                                                                                text-color="black">
                                                                                {{
                                                                                    calcularIdade(ficha.dataNascimento).idade
                                                                                }} anos
                                                                                <v-img class="ml-1"
                                                                                    src="../assets/age-group_3787841.png"
                                                                                    max-height="26"
                                                                                    max-width="26"></v-img>
                                                                                <!-- mdi-cake-variant -->
                                                                            </v-chip>
                                                                            <v-chip outlined
                                                                                v-show="calcularIdade(ficha.dataNascimento).fazAniversarioNoMesAtual">
                                                                                <v-icon left color="blue">
                                                                                    calendar_month
                                                                                </v-icon>
                                                                                <strong>{{
                                                                                    calcularIdade(ficha.dataNascimento).diaAniversario
                                                                                    }}</strong>
                                                                                <v-icon right color="pink">
                                                                                    mdi-cake-variant
                                                                                </v-icon>
                                                                            </v-chip>
                                                                        </v-layout>
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-card>
                                                        <v-card class="mt-2" outlined>
                                                            <v-card-text>
                                                                <h3>
                                                                    <v-layout row justify-center align-center>
                                                                        Exame(s):
                                                                        <div class="pl-2">
                                                                            {{ ficha.nomeExame }}
                                                                        </div>

                                                                        <v-btn v-show="listaConsultasPaciente.length"
                                                                            icon small @click="show = !show">
                                                                            + {{ listaConsultasPaciente.length - 1
                                                                            }}
                                                                        </v-btn>
                                                                    </v-layout>
                                                                </h3>

                                                                <div v-show="show" class="animated fadeInDown">
                                                                    <!-- <v-divider /> -->
                                                                    <v-card-text>
                                                                        <div v-for="(consulta, index) in listaConsultasPaciente"
                                                                            :key="index">
                                                                            <div
                                                                                v-show="ficha.idExame !== consulta.idExame">
                                                                                <strong :class="consulta.colorText">
                                                                                    {{ consulta.nomeExame }}
                                                                                </strong>
                                                                                <v-divider
                                                                                    v-if="index + 1 < listaConsultasPaciente.length"
                                                                                    :key="index" />
                                                                            </div>
                                                                        </div>
                                                                    </v-card-text>
                                                                </div>

                                                                <div justify-end>
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on }">
                                                                            <button
                                                                                @click="onCopy(ficha.idOrdemServico)"
                                                                                type="button" v-on="on">
                                                                                Copiar O.S!
                                                                            </button>

                                                                        </template>
                                                                        <span>{{ textClipBoard }}</span>
                                                                    </v-tooltip>
                                                                </div>
                                                                <strong>OS: {{ ficha.idOrdemServico }}</strong>
                                                            </v-card-text>
                                                            <v-divider />

                                                            <v-card-actions v-if="ficha.codigo ">
                                                                <v-btn class="rounded-card" color="" @click="voltar(), iniciouAtendimento = false, isAtendidos = false">
                                                                    <v-icon left>
                                                                        keyboard_backspace
                                                                    </v-icon>
                                                                    voltar
                                                                </v-btn>

                                                                <div v-if="isAtendimento && user.tecnico == 1"
                                                                    class="ml-4">
                                                                    <!--lista de espera-->
                                                                    <anamnese :ficha="ficha" />
                                                                </div>

                                                                <div v-if="isAtendimento && user.tecnico == 1" class="ml-2">
                                                                    <preLaudo :user="user" :ficha="ficha" :listaConsultasPaciente="listaConsultasPaciente" />
                                                                </div>

                                                            </v-card-actions>
                                                        </v-card>
                                                    </div>

                                                    <div v-if="loadAtendidos">
                                                        <v-skeleton-loader>
                                                            <!-- List item avatar three line -->
                                                            <v-list-item two-line>
                                                            <v-list-item-avatar>
                                                                <v-skeleton-loader type="avatar"></v-skeleton-loader>
                                                            </v-list-item-avatar>

                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                <v-skeleton-loader type="text"></v-skeleton-loader>
                                                                </v-list-item-title>
                                                                <v-list-item-subtitle>
                                                                <v-skeleton-loader type="text"></v-skeleton-loader>
                                                                </v-list-item-subtitle>
                                                                <v-list-item-subtitle>
                                                                <v-skeleton-loader type="text"></v-skeleton-loader>
                                                                </v-list-item-subtitle>
                                                            </v-list-item-content>
                                                            </v-list-item>

                                                            <!-- Image -->
                                                            <v-list-item-content>
                                                            <v-list-item-title>
                                                                <v-skeleton-loader type="text"></v-skeleton-loader>
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                <v-skeleton-loader type="text"></v-skeleton-loader>
                                                            </v-list-item-subtitle>
                                                            <v-list-item-subtitle>
                                                                <v-skeleton-loader type="text"></v-skeleton-loader>
                                                            </v-list-item-subtitle>
                                                            </v-list-item-content>

                                                            <div class="d-flex align-center flex-nowrap">
                                                                <v-skeleton-loader
                                                                    type="heading"
                                                                    width="200"
                                                                    height="36"
                                                                    style="margin-right: -100px;"
                                                                ></v-skeleton-loader>

                                                                <v-skeleton-loader
                                                                    type="heading"
                                                                    width="200"
                                                                    height="36"
                                                                    style="margin-right: -100px;"
                                                                ></v-skeleton-loader>

                                                                <v-skeleton-loader
                                                                    type="heading"
                                                                    width="200"
                                                                    height="36"
                                                                ></v-skeleton-loader>
                                                            </div>
                                                        </v-skeleton-loader>
                                                    </div>
                                                </v-card>
                                                <div v-if="listaPacientesAtendidos.length == 0">
                                                    <v-card flat width="434">
                                                        <div v-for="i in 6" :key="i">
                                                            <v-skeleton-loader class="mx-auto"
                                                                type="list-item-avatar-two-line"
                                                                :loading="true"></v-skeleton-loader>
                                                        </div>
                                                    </v-card>
                                                </div>
                                            </v-container>
                                        </v-tab-item>

                                    </v-tabs>
                                    <v-dialog v-model="dialogEstatisticas" hide-overlay fullscreen
                                        transition="dialog-bottom-transition">
                                        <div v-if="dialogEstatisticas">
                                            <estatisticas @fechar="dialogEstatisticas = false" />
                                        </div>
                                    </v-dialog>
                                    <v-dialog v-model="dialogMeusAtendimentos" hide-overlay fullscreen persistent
                                        transition="dialog-bottom-transition">
                                        <div v-if="dialogMeusAtendimentos">
                                            <atendimentos @fechar="dialogMeusAtendimentos = false" />
                                        </div>
                                    </v-dialog>
                                    <v-dialog v-model="dialogPacientes" hide-overlay fullscreen persistent
                                        transition="dialog-bottom-transition">
                                        <div v-if="dialogPacientes">
                                            <pacientes @fechar="dialogPacientes = false" />
                                        </div>
                                    </v-dialog>
                                    <v-dialog v-model="dialogModelo" hide-overlay fullscreen
                                        transition="dialog-bottom-transition">
                                        <modeloProntuario v-if="dialogModelo" @fechar="dialogModelo = false" />
                                    </v-dialog>

                                    <!-- <v-speed-dial v-if="user.tecnico == 0" v-model="fab" right absolute bottom fab>
                                            <template v-slot:activator>
                                                <v-btn v-model="fab" color="blue darken-2" dark fab right>
                                                    <v-icon v-if="fab">
                                                        mdi-close
                                                    </v-icon>
                                                    <v-icon v-else>
                                                        more_vert
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ attrs, on }">
                                                    <v-btn dark small fab color="green" v-if="user.tecnico == 0"
                                                        v-bind="attrs" v-on="on" @click="dialogPacientes = true">
                                                        <v-icon color="white">search</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Pacientes</span>
                                            </v-tooltip>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ attrs, on }">
                                                    <v-btn dark small fab color="indigo" v-if="user.tecnico == 0"
                                                        v-bind="attrs" v-on="on" @click="dialogMeusAtendimentos = true">
                                                        <v-icon color="white">history</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Meus Atendimentos</span>
                                            </v-tooltip>

                                            <v-tooltip right>
                                                <template v-slot:activator="{ attrs, on }">
                                                    <v-btn small fab color="orange" v-if="user.tecnico == 0"
                                                        v-bind="attrs" v-on="on" @click="dialogEstatisticas = true">
                                                        <v-icon color="white">trending_up</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Estatísticas</span>
                                            </v-tooltip>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ attrs, on }">
                                                    <v-btn small fab color="blue-grey darken-1" v-if="user.tecnico == 0"
                                                        v-bind="attrs" v-on="on" @click="dialogModelo = true">
                                                        <v-icon color="white">settings</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Pré-definições</span>
                                            </v-tooltip>

                                        </v-speed-dial> -->

                                </v-card>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-alert class="mt-4 rounded-xl animated fadeIn" dense
                                    v-show="qtdChamadasPrioridade > 0" light>
                                    <v-layout justify-center>
                                        <v-icon color="info" left>wheelchair_pickup</v-icon> Existe(m) <strong
                                            class="info--text">{{
                                                qtdChamadasPrioridade }} </strong> paciente(s)
                                        com atendimento preferencial.
                                    </v-layout>
                                </v-alert>
                            </v-flex>

                        </v-flex>
                    </v-layout>
                </v-container>
            </div>

        </v-container>
        <div>
            <v-dialog v-model="dialoConsultasPaciente" persistent min-height="300px" max-width="350px">
                <v-card >
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>Consultas realizadas</v-toolbar-title>
                        <v-spacer />

                        <v-btn icon>
                            <v-icon @click="fecharDialogConsultasPaciente">
                                close
                            </v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-divider />
                    <v-window v-model="step">
                        <v-window-item v-for="(grupoConsultas, index) in listaConsultasPacienteAgrupada"
                            :key="`grupo-${grupoConsultas[0] ? grupoConsultas[0].idUnidade : index}`" :value="index">
                            <v-card-text>
                                <v-list class="scroll-y" style="height:300px;" subheader one-line>
                                    <v-subheader>{{ grupoConsultas[0].nomeUnidade }}</v-subheader>
                                    <template v-for="(consulta, consultaIndex) in grupoConsultas">
                                        <v-list-item
                                            :key="consulta.idConsulta || `${consulta.idExame}-${consultaIndex}`"
                                            :class="consulta.cor" ripple
                                            :disabled="consulta.showCheck == false || consulta.idUnidade != localEscolhido.idUnidade">

                                            <v-list-item-content @click="toggleConsulta(consulta)">
                                                <v-list-item-title>
                                                    <v-icon class="mr-2" v-text="consulta.status == true? 'check_box': 'check_box_outline_blank'" :color="consulta.status == true? 'primary': ''" ></v-icon>
                                                    {{
                                                        consulta.nomeExame
                                                    }}
                                                </v-list-item-title>
                                            </v-list-item-content>

                                        </v-list-item>
                                        <v-divider
                                            v-if="consultaIndex + 1 < grupoConsultas.length"
                                            :key="`divider-${consulta.idConsulta || consultaIndex}`" />
                                    </template>
                                </v-list>
                            </v-card-text>
                        </v-window-item>
                    </v-window>
                    <v-card-actions class="pr-4">
                        <v-spacer />
                        <v-btn :loading="loadFinalizar" rounded color="primary" dark @click="encerrarAtendimento">
                            Finalizar Atendimento
                        </v-btn>
                        <v-spacer />
                        <v-icon large :disabled="step === 0 || loadFinalizar" @click="step--">
                            arrow_left
                        </v-icon>
                        <v-icon large :disabled="step == listaConsultasPacienteAgrupada.length - 1
                            || loadFinalizar" @click="step++">
                            arrow_right
                        </v-icon>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogNaoExecutouExame" max-width="500">
                <v-card>
                    <v-card-title class="headline red lighten-2 white--text">
                        Você deve escolher um exame para finalizar o atendimento
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="green darken-1" text="text" @click="dialogNaoExecutouExame = false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogConfirmarSaida" max-width="360">
                <v-card>
                    <v-card-title class="headline red lighten-1 white--text">
                        Deseja realmente sair ?
                    </v-card-title>

                    <v-card-text v-if="listaPacientesPendente.length || listaPacientesEspera.length">
                        Você possue paciente(s) pendente(s) ou em espera.
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="black darken-1" text="text" @click="dialogConfirmarSaida = false">
                            Voltar
                        </v-btn>
                        <v-spacer />
                        <v-btn color="red darken-1" text="text" @click="logout">
                            Sair
                        </v-btn>
                        <!-- <v-btn v-if="listaPacientesPendente.length" color="green darken-1" text="text" @click="liberarPacientes()">Liberar</v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogChamadaJaFeita" width="500">
                <v-card>
                    <v-card-title class="white--text headline red lighten-2 pl-4" primary-title>
                        Paciente já chamado
                    </v-card-title>

                    <v-card-text>
                        Essa Paciente já foi chamada por um outro Médico.
                        <strong class="red--text text--lighten-1">Clique em Voltar,</strong>
                        escolha outro paciente da lista para chamá-lo.
                        <br>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" text @click="dialogChamadaJaFeita = false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogProximoAtendimento" persistent max-width="490">
                <v-card>
                    <v-card-title class="white--text headline teal lighten-1">
                        <v-flex row>
                            <p class="text-center">
                                {{ mensagemCabecalhoProximoAtendimento }}
                            </p>
                        </v-flex>
                    </v-card-title>
                    <v-divider />
                    <div v-if="possuiProximoAtendimento">
                        <v-card-text v-if="mensagemIdProximaUnidade != localEscolhido.idUnidade" row class="title">
                            Unidade: {{ mensagemProximaUnidade }}
                        </v-card-text>
                        <v-divider />
                        <v-card-text v-if="consultas.length == 1" class="pa-2 title">
                            Serviço: {{ mensagemProximoServico }}
                        </v-card-text>
                        <v-card-text v-if="consultas.length == 1" class="pa-2 title">
                            Exame: {{ mensagemProximoExame }}
                        </v-card-text>

                        <v-card-text class="pa-2 title">
                            Local: {{ mensagemProximoLocalDialog }}
                        </v-card-text>
                        <!-- <v-divider></v-divider>          -->
                    </div>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="green darken-1" text @click="dialogProximoAtendimento = false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogNaoCompareceu" persistent max-width="490">
                <!-- <template v-slot:activator="{ on }" /> -->
                <v-card>
                    <v-card-title class="white--text headline red lighten-2">
                        Deseja alocar este Paciente na lista de Pacientes pendentes?
                    </v-card-title>
                    <v-card-text>O Paciente será adicionado na lista de Pacientes pendentes.</v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="green darken-1" text @click="dialogNaoCompareceu = false">
                            Não
                        </v-btn>
                        <v-btn color="green darken-1" text @click="chamadaNaoAtendida()">
                            Sim
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="aguardandoConexao" persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Aguardando conexão...
                        <v-progress-linear indeterminate color="white" class="mb-0" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="alertEspera" persistent width="400">
                <v-card color="primary darken-2" dark>
                    <v-card-title class="headline white--text">
                        Adicionar Paciente em Espera
                    </v-card-title>
                    <v-divider />

                    <v-card-text>
                        <p class="white--text">Os pacientes adicionados à fila de espera não mantêm os dados salvos.
                            Caso
                            adicione em espera, terá que lançar os dados novamente.</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn text @click="alertEspera = false">
                            voltar
                        </v-btn>
                        <v-btn color="primary" rounded text @click="adiconarAtendimentoEmEspera">
                            adicionar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <!-- </v-main> -->
        <!-- {{ ficha }} -->
    </v-layout>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import {
    mask
} from "vue-the-mask";
import Typed from "typed.js";
import {
    getToken,
    setToken
} from "../store/auth";
import medicoService from "../services/medico.service";
import filaMedicaServise from "../services/filaMedicaService";
import socketService from "../services/socket.service";
import {
    Socket
} from "dgram";
import HelperMedico from "./../components/helper/Helper";
import {
    log
} from "util";
import Prontuario from '../components/medico/prontuario.vue';
import Estatisticas from '../components/medico/estatisticas.vue'
import Atendimentos from '../components/medico/atendimentos.vue'
import ModeloProntuario from "../components/medico/modeloProntuario.vue";
import posAtendimentoService from "../services/posAtendimento.service";
import Pacientes from '../components/medico/pacientes.vue'
import Anamnese from '../components/tecnico/anamnese.vue'
import PreLaudo from '../components/tecnico/laudoTecnico.vue'
import { EventBus } from '../main'


export default {
    name: "HomeMedico",
    directives: {
        mask
    },
    components: {
        HelperMedico,
        'prontuario': Prontuario,
        'anamnese': Anamnese,
        'estatisticas': Estatisticas,
        'atendimentos': Atendimentos,
        'pacientes': Pacientes,
        'modeloProntuario': ModeloProntuario,
        'preLaudo': PreLaudo

    },
    data() {
        return {
            dialogHelp: false,
            listaHelp: [],
            load: false,
            selected: [2],
            dadosProntuario: null,
            index: '',
            isLocalAutomatico: false,
            primeiraChamadaAutomatica: true,
            receita: [],
            solicitacao: [],
            selectedCard: '',
            laudo: '',
            addNew: false,
            loadFinalizar: false,
            alertEspera: false,
            dialogModelo: false,
            mProntuario: [],
            deleteConfirmed: false,
            listaPacientesAtendidos: [],
            mask: "#######",
            nomeConsultorioRules: [
                v => (v && v.length > 1) || "Nome deve ter 2 ou mais caracteres"
            ],
            blockMethod: false,
            textButtonEsquerdo: "pacientes pendentes",
            textButtonDireito: "pacientes em espera",
            btnColorEsquerda: "primary",
            btnColorDireita: "green darken-1",
            items: [{
                id: 1,
                name: "Applications :",
                children: [{
                    id: 2,
                    name: "Calendar : app"
                },
                {
                    id: 3,
                    name: "Chrome : app"
                },
                {
                    id: 4,
                    name: "Webstorm : app"
                }
                ]
            }],
            show: false,
            interval: "",
            qtdChamadasPrioridade: 0,
            addedFicha: false,
            emRefreshToken: false,
            textClipBoard: "Copiar O.S",
            step: 0,
            listaUnidades: [],
            unidadeSelecionada: "",
            varAguardandoConexao: 0,
            listaServicosDoMedico: [],
            listaServicos: [],
            listaLocais: [],
            valid: true,
            localEscolhido: "",
            nomeConsultorio: "",
            possuiProximoAtendimento: false,
            consultas: [],
            desabilitaBotaoChamar: false,
            drawer: null,
            fezChamada: false,
            emPacientePendente: false,
            emPacienteEspera: false,
            isAtendimento: false,
            user: "",
            radioProximoPaciente: "",
            nChamada: 0,
            socket: "",
            socketAux: "",
            intervalos: [],
            habilitarBotaoCronometro: false,
            intervalContagemRegressiva: "",
            textCronometroRegressivo: "[00:40]",
            minutesRegressivo: "",
            secondsRegressivo: "",
            tempoAtendimento: "00:00:00",
            seconds: 0 * 60,
            isPendentes: false,
            rulesConsultorioLaboratorio: [],
            isEspera: false,
            minutosAtendimento: "",
            botaoInicialDesabilitado: false,
            mensagemCabecalhoProximoAtendimento: "",
            mensagemProximoServico: "",
            mensagemProximoExame: "",
            mensagemProximaUnidade: "",
            mensagemIdProximaUnidade: "",
            mensagemAutomatico: "",
            mensagemProximoLocal: "",
            mensagemProximoLocalMontada: "",
            mensagemProximoLocalDialog: "",
            idLocalMedico: "",
            dialogChamadaJaFeita: false,
            dialogProximoAtendimento: false,
            dialogNaoExecutouExame: false,
            dialoConsultasPaciente: false,
            listaPacientesDisponiveisFiltrada: [],
            listaPacientesPendenteFiltrada: [],
            listaPacientesEsperaFiltrada: [],
            listaPacientesAtendidosFiltrada: [],
            listaDeCredenciais: [],
            itensTesteInterface: [
                [{
                    idConsulta: 10525,
                    idUnidade: 1,
                    idServico: 58,
                    idExame: 119,
                    nomeExame: "AUDIOMETRIA TONAL",
                    nomeUnidade: "CM REMEDIOS-CENTRO",
                    dataChegada: null,
                    status: false,
                    idMedico: null,
                    cor: "grey lighten-1",
                    showCheck: false
                },
                {
                    idConsulta: 10527,
                    idUnidade: 1,
                    idServico: 12,
                    idExame: 357,
                    nomeExame: "ASO-EXAME CLINICO",
                    nomeUnidade: "CM REMEDIOS-CENTRO",
                    dataChegada: "2020-05-14T19:28:39.000Z",
                    status: false,
                    idMedico: 1,
                    cor: "",
                    showCheck: true
                },
                {
                    idConsulta: 10527,
                    idUnidade: 1,
                    idServico: 12,
                    idExame: 357,
                    nomeExame: "ASO-EXAME CLINICO",
                    nomeUnidade: "CM REMEDIOS-CENTRO",
                    dataChegada: "2020-05-14T19:28:39.000Z",
                    status: false,
                    idMedico: 1,
                    cor: "",
                    showCheck: true
                },
                {
                    idConsulta: 10526,
                    idUnidade: 1,
                    idServico: 37,
                    idExame: 1350,
                    nomeExame: "EXAMES DE LABORATORIO",
                    nomeUnidade: "CM REMEDIOS-CENTRO",
                    dataChegada: null,
                    status: false,
                    idMedico: null,
                    cor: "grey lighten-1",
                    showCheck: false
                },
                {
                    idConsulta: 10526,
                    idUnidade: 1,
                    idServico: 37,
                    idExame: 1350,
                    nomeExame: "EXAMES DE LABORATORIO",
                    nomeUnidade: "CM REMEDIOS-CENTRO",
                    dataChegada: null,
                    status: false,
                    idMedico: null,
                    cor: "grey lighten-1",
                    showCheck: false
                },
                {
                    idConsulta: 10526,
                    idUnidade: 1,
                    idServico: 37,
                    idExame: 1350,
                    nomeExame: "EXAMES DE LABORATORIO",
                    nomeUnidade: "CM REMEDIOS-CENTRO",
                    dataChegada: null,
                    status: false,
                    idMedico: null,
                    cor: "grey lighten-1",
                    showCheck: false
                },
                {
                    idConsulta: 10528,
                    idUnidade: 1,
                    idServico: 36,
                    idExame: 732,
                    nomeExame: "RADIOGRAFIA TORAX P.A.",
                    nomeUnidade: "CM REMEDIOS-CENTRO",
                    dataChegada: null,
                    status: false,
                    idMedico: null,
                    cor: "",
                    showCheck: true
                }
                ]
            ],
            dialogConfirmarSaida: false,
            listaPacientes: [],
            tamlistaPacientes: 0,
            listaPacientesDisponiveis: [],
            listaPacientesPendente: [],
            listaPacientesEspera: [],
            searchDisponiveis: "",
            searchPendentes: "",
            searchEspera: "",
            searchAtendidos: "",
            listaConsultasPaciente: [],
            listaConsultasPacienteAgrupada: [],
            dialogNaoCompareceu: false,
            nomePaciente: "",
            consultasFinalisadas: [],
            aguardandoConexao: false,
            contadorAguardandoConexao: 1,
            iniciouAtendimento: false,
            mensagemNotificacaoSocket: "default",
            ficha: {
                codigo: "",
                idServico: "",
                nomeEspecialidade: "",
                idAtendimento: "",
                idLocal: "",
                idExamesos: "",
                nomePaciente: "",
                status: "",
                idExame: "",
                prioridade: "",
                dataStatus: null,
                dataFinalAtendimento: null,
                dataStatusCronometro: null,
                idLocalMedico: "",
                nomeExame: "",
                dataNascimento: "",
                idade: "",
                idOrdemServico: "",
                idConsulta: "",
                atendimentos: []
            },
            exibirListaEspera: false,
            listaServicosDisponibilidade: [],
            mostrarTelaPrincipal: false,
            listaServicosSelecionados: "",
            listaServicosEscolhidos: [],
            rulesLocal: [
                v => (v && v.length <= 5) || "Mínimo 1 e máximo 5 caracteres",
                v => v[0] != " " || "Não pode iniciar com espaço em branco!!"
            ],
            descricaoLocal: {
                descricao: "Consultório ",
                valor: "Consultório "
            },
            nomeConsultorioCompleto: "",
            itensDescricaoLocal: [{
                descricao: "Laboratório ",
                valor: "Laboratório "
            },
            {
                descricao: "Consultório ",
                valor: "Consultório "
            },
            {
                descricao: "Sala ",
                valor: "Sala "
            },
            {
                descricao: "Outros ",
                valor: ""
            }
            ],
            fab: false,
            dialogEstatisticas: false,
            dialogMeusAtendimentos: false,
            dialogPacientes: false,
            loadAtendidos: false,
            isAtendidos: false
        };
    },

    methods: {
        carregarDadosProntuario(dados) {
            this.dadosProntuario = dados;
        },
        confirmDelete() {
            if (!this.deleteConfirmed) {
                // Primeiro clique: habilitar o botão de exclusão final
                this.deleteConfirmed = true;
                setTimeout(() => {
                    // Reverter o estado após 5 segundos para evitar exclusão acidental
                    this.deleteConfirmed = false;
                }, 5000);
            } else {
                // Segundo clique: efetuar a exclusão
                if (this.selectedCard) {
                    console.log("Excluído:", this.selectedCard);
                    medicoService.medico.removerCredenciaisAtendimento(this.selectedCard).then(r => {
                        if (r.status == 200) {
                            this.selectedCard = ''
                            this.listarCredenciaisAtendimento()
                        }
                    })
                    this.deleteConfirmed = false;
                }
            }
        },
        editSelection() {
            var credenciais = null
            for (let i = 0; i < this.listaDeCredenciais.length; i++) {
                const element = this.listaDeCredenciais[i]
                if (element._id == this.selectedCard) {
                    credenciais = element
                    break
                } 
            }
            
            if (credenciais != null) {
                    this.agruparLocaisPorUnidade(credenciais.unidade)
                     this.agruparServicosPorLocal(credenciais.local)
                     this.user.id = credenciais.idUsuario
                     this.unidadeSelecionada = credenciais.unidade
                     this.localEscolhido = credenciais.local
                     this.listaServicosSelecionados = credenciais.servicos
                     this.descricaoLocal = credenciais.consultorio
                     this.nomeConsultorio = credenciais.localConsultorio
                     this.addNew = true
            }
            
        },
        confirmSelection() {
            var credenciais = null
            for (let i = 0; i < this.listaDeCredenciais.length; i++) {
                const element = this.listaDeCredenciais[i]
                if (element._id == this.selectedCard) {
                    credenciais = element
                    break
                } 
            }
            if (credenciais != null) {
                     this.agruparLocaisPorUnidade(credenciais.unidade)
                     this.agruparServicosPorLocal(credenciais.local)
                     this.user.id = credenciais.idUsuario
                     this.unidadeSelecionada = credenciais.unidade
                     this.localEscolhido = credenciais.local
                     this.listaServicosSelecionados = credenciais.servicos
                     this.descricaoLocal = credenciais.consultorio
                     this.nomeConsultorio = credenciais.localConsultorio
                    
                    
                     //this.addNew = true
                     this.adicionarServicosParaAtendimento()
            }
            console.log("Selecionado:", this.selectedCard);
        },
        isLastService(servicos, servicoAtual) {
            return servicos[servicos.length - 1] === servicoAtual;
        },
        addVoltar() {
            this.show = false;
            this.isEspera = false;
            this.fezChamada = false;
            this.isAtendimento = false;
            this.addedFicha = false;
            this.nChamada = 0;
            //(this.isPendentes = false),
            this.iniciouAtendimento = false;
            (this.ficha.senha = ""),
                (this.ficha.codigo = ""),
                (this.ficha.nomeEspecialidade = ""),
                (this.ficha.nomePaciente = ""),
                (this.ficha.idAtendimento = ""),
                (this.ficha.idLocal = "");
            this.blockMethod = false;
        },
        addReceita(data) {
            this.receita = data
        },
        addLaudo(data) {
            this.laudo = data
        },
        parseCsv(value) {
            if (value == null || value === "") {
                return [];
            }

            return String(value)
                .split(",")
                .map(item => item.trim())
                .filter(Boolean);
        },
        addProntuario(data) {
            //console.log('----- data: ', data)
            this.mProntuario = data
        },
        addSolicitacao(data) {
            this.solicitacao = data
        },
        toggleConsulta(consulta) {
            consulta.status = !consulta.status;
            this.ficha.idExamesos = consulta.idexamesos == null ? this.ficha.idExamesos : consulta.idexamesos;
        },
        clearSearch() {
            this.search = "";
        },
        alterarDialogHelp() {
            this.dialogHelp = false;
        },

        retornarHelp() {
            if (!this.blockMethod) {
                this.blockMethod = true;
                if (this.chamouListaHelp) {
                    this.dialogHelp = true;
                    this.blockMethod = false;
                    return;
                }

                medicoService.medico
                    .retornarHelp(4)
                    .then(rsp => {
                        console.log("rsp retornarHelp:", rsp);
                        if (rsp.status == 200) {
                            this.chamouListaHelp = true;
                            this.listaHelp = this.groupBy(rsp.data, "idTituloHelp");
                            this.dialogHelp = true;
                        }
                        this.blockMethod = false;
                    })
                    .catch(err => {
                        //handle your error here
                        this.blockMethod = false;
                        console.log(err);
                    });
            }
        },

        verificarLocalAutomatico(idLocal) {
            //idLocal escolhido pelo médico
            medicoService.medico
                .verificarLocalAutomatico(idLocal)
                .then(rsp => {
                    console.log("rsp verificarLocalAutomatico:", rsp.data);
                    this.isLocalAutomatico = rsp.data.automatico;
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        chamadaAutomatica() {
            if (this.isLocalAutomatico) {
                console.log("em  chamada automatica");
                if (this.primeiraChamadaAutomatica) {
                    //chama 2
                    var contador = 0;
                    this.listaPacientesDisponiveis.forEach(element => {
                        if (!element.idLocalAutomatico && contador < 2) {
                            contador++;
                            this.primeiraChamadaAutomatica = false;
                            this.fazerChamadaAutomatico(element);
                        }
                    });
                } else {
                    //chama 1
                    var element = this.listaPacientesDisponiveis.find(
                        element => !element.idLocalAutomatico
                    );
                    if (element) {
                        this.fazerChamadaAutomatico(element);
                    }
                }
            }
        },

        fazerChamadaAutomatico(ficha) {
            var automatico = true;
            medicoService.medico
                .fazerChamada(
                    ficha.idAtendimento,
                    ficha.codigo,
                    this.nomeConsultorio,
                    ficha.idConsulta,
                    this.user.nome,
                    ficha.nomePaciente,
                    ficha.prioridade,
                    ficha.idLocalMedico,
                    this.localEscolhido.nomeLocal,
                    this.user.tecnico,
                    automatico,
                    this.localEscolhido.idLocal
                )
                .then(rsp => {
                    console.log("rsp fazerChamadaAutomatico:", rsp);
                    if (rsp.data == true) {
                        //this.dialogChamadaJaFeita = true;
                    }
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        fazerChamada() {
            //ok
            this.desabilitaBotaoChamar = true;
            // Re-enable after 5 seconds
            this.timeout = setTimeout(() => {
                this.desabilitaBotaoChamar = false;
            }, 15000);
            var automatico = false;

            medicoService.medico
                .fazerChamada(
                    this.ficha.idAtendimento,
                    this.ficha.codigo,
                    this.nomeConsultorio,
                    this.ficha.idConsulta,
                    this.user.nome,
                    this.ficha.nomePaciente,
                    this.ficha.prioridade,
                    `${this.user.idLocal}`,
                    this.localEscolhido.nomeLocal,
                    this.user.tecnico,
                    automatico,
                    this.localEscolhido.idLocal,
                    this.ficha.idPaciente,
                    this.ficha.dataNascimento
                )
                .then(rsp => {
                    console.log("rsp fazerChamada:", rsp);
                    if (rsp.data == true) {
                        this.listaPacientesPendente.forEach((element, index) => {
                            if (element.idAtendimento == this.ficha.idAtendimento) {
                                this.listaPacientesPendente.splice(index, 1);
                            }
                        });

                        this.habilitarBotaoCronometro == true ||
                            this.intervalContagemRegressiva ?
                            "" :
                            this.chamarCronometroRegressivo();
                        this.fezChamada = true;
                        this.nChamada = this.nChamada + 1;
                        this.emPacientePendente = false;
                    }
                    if (rsp.data == false) {
                        this.dialogChamadaJaFeita = true;
                    }
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        chamarCronometroRegressivo() {
            // 45 seg = 0.75
            this.minutesRegressivo = 0.05;
            this.secondsRegressivo = 40;
            this.intervalContagemRegressiva = setInterval(
                () => this.iniciarCronometroRegressivo(),
                1000
            );
        },

        iniciarCronometroRegressivo() {
            var min = Math.floor(this.secondsRegressivo / 60);
            var sec = this.secondsRegressivo - min * 60;
            sec === 0 ? (sec = "00") : "";
            sec > 0 && sec < 10 ? (sec = "0" + sec.toString()) : "";
            this.textCronometroRegressivo =
                "[" + "0" + min.toString() + ":" + sec + "]";
            this.secondsRegressivo--;
            if (this.secondsRegressivo === -1) {
                this.textCronometroRegressivo = "";
                this.secondsRegressivo--;
                this.habilitarBotaoCronometro = true;
                clearInterval(this.intervalContagemRegressiva);
            }
        },

        chamarCronometro() {
            var i1 = setInterval(() => this.iniciarCronometroAtendimento(), 1000);
            this.intervalos.push(i1);
        },

        iniciarCronometroAtendimento() {
            this.seconds += 1;
            const hours = Math.floor(this.seconds / 3600);
            const minutesLeft = Math.floor(this.seconds / 60) % 60;
            const secondsLeft = this.seconds % 60;
            this.tempoAtendimento =
                this.timeDurationToString(hours) +
                ":" +
                this.timeDurationToString(minutesLeft) +
                ":" +
                this.timeDurationToString(secondsLeft);
        },

        exibirListaPendentes() {
            if (this.listaPacientesPendente.length) {
                this.textButtonEsquerdo = "pacientes disponiveis";
                this.btnColorEsquerda = "primary";
                this.textButtonDireito = "pacientes em espera";
                this.btnColorDireita = "green darken-1";
                this.exibirListaEspera = false;
                this.isPendentes = true;
            } else if (this.listaPacientesDisponiveis.length) {
                this.textButtonEsquerdo = "pacientes pendentes";
                this.btnColorEsquerda = "primary";
                this.textButtonDireito = "pacientes em espera";
                this.btnColorDireita = "green darken-1";
                this.exibirListaEspera = false;
                this.isPendentes = false;
            }
        },

        modificarListaPacientes() {
            console.log("modfList");
            if (this.exibirListaEspera && this.isPendentes) {
                this.exibirListaEspera = false;
            } else if (this.exibirListaEspera && !this.isPendentes) {
                this.exibirListaEspera = false;
            } else if (!this.exibirListaEspera && this.isPendentes) {
                this.btnColorEsquerda = "primary";
                this.isPendentes = !this.isPendentes;
            } else if (!this.exibirListaEspera && !this.isPendentes) {
                this.btnColorEsquerda = "primary";
                this.isPendentes = !this.isPendentes;
            }
        },
        changeColor(id) {
            this.voltar()
            switch (id) {
                case 1:
                    this.exibirListaEspera = false;
                    this.isPendentes = true;
                    break;
                case 2:
                    this.exibirListaEspera = true;
                    this.isPendentes = false;
                    break;
                default:
                    this.exibirListaEspera = false;
                    this.isPendentes = false;
                    break;
            }
            /*
            if (id == 1) {
              if (this.textButtonDireito == "pacientes pendentes") {
                if (this.exibirListaEspera) {
                  this.textButtonDireito = "pacientes em espera";
                  this.btnColorDireita = "green darken-1";
                  this.exibirListaEspera = false;
                  this.isPendentes = true;
                } else {
                  this.textButtonDireito = "pacientes disponiveis";
                  this.btnColorDireita = "primary";
                  this.isPendentes = true;
                }
              } else if (this.textButtonDireito == "pacientes disponiveis") {
                if (this.exibirListaEspera) {
                  this.textButtonDireito = "pacientes em espera";
                  this.btnColorDireita = "green darken-1";
                  this.exibirListaEspera = false;
                  this.isPendentes = false;
                } else {
                  this.textButtonDireito = "pacientes pendentes";
                  this.btnColorDireita = "primary";
                  this.isPendentes = false;
                }
              } else if (this.textButtonDireito == "pacientes em espera") {
                if (this.isPendentes) {
                  this.textButtonDireito = "pacientes pendentes";
                  this.btnColorDireita = "primary";
                  this.exibirListaEspera = true;
                  this.isPendentes = false;
                } else {
                  this.textButtonDireito = "pacientes disponiveis";
                  this.btnColorDireita = "primary";
                  this.exibirListaEspera = true;
                }
              }
            } else {
              if (this.textButtonEsquerdo == "pacientes pendentes") {
                if (this.exibirListaEspera) {
                  this.textButtonEsquerdo = "pacientes em espera";
                  this.btnColorEsquerda = "green darken-1";
                  this.exibirListaEspera = false;
                  this.isPendentes = true;
                } else {
                  this.textButtonEsquerdo = "pacientes disponiveis";
                  this.btnColorEsquerda = "primary darken-1";
                  this.isPendentes = true;
                }
              } else if (this.textButtonEsquerdo == "pacientes disponiveis") {
                if (this.exibirListaEspera) {
                  this.textButtonEsquerdo = "pacientes em espera";
                  this.btnColorEsquerda = "green darken-1";
                  this.exibirListaEspera = false;
                  this.isPendentes = false;
                } else {
                  this.textButtonEsquerdo = "pacientes pendentes";
                  this.btnColorEsquerda = "primary";
                  this.isPendentes = false;
                }
              } else if (this.textButtonEsquerdo == "pacientes em espera") {
                if (this.isPendentes) {
                  this.textButtonEsquerdo = "pacientes pendentes";
                  this.btnColorEsquerda = "primary";
                  this.exibirListaEspera = true;
                  this.isPendentes = false;
                } else {
                  this.textButtonEsquerdo = "pacientes disponiveis";
                  this.btnColorEsquerda = "primary";
                  this.exibirListaEspera = true;
                }
              }
            } */
        },

        vertificarExameMedico(element) {
            var encontrou = false;
            if (element.idMedico == null || element.idMedico == this.user.id) {
                if (this.listaServicosSelecionados[element.idServico] != null) {
                    if (
                        this.listaServicosSelecionados[element.idServico].examesIndexados[
                        element.idExame
                        ] != null
                    ) {
                        encontrou = true;
                        console.log("encontrou !!!!", element);
                    }
                }
            }
            if (encontrou) {
                return true;
            } else {
                return false;
            }
        },

        onCopy: async function (e) {
            try {
                await navigator.clipboard.writeText(e);
                alert('O.S copiada para a área de tranferência')
            } catch ($e) {
                alert('Cannot copy');
            }
            /*this.textClipBoard = "aO.S copiada para a área de tranferênci";
            this.timeout = setTimeout(() => {
              this.textClipBoard = "Copiar O.S";
            }, 6000);*/
            //alert('Ordem de serviço copiada: ' + e.text)
        },

        onError: function (e) {
            this.textClipBoard = "Erro ao copiar O.S";
            this.timeout = setTimeout(() => {
                this.textClipBoard = "Copiar O.S";
            }, 6000);
        },

        chamarPacienteDialog() {
            var paciente = this.listaPacientesDisponiveis[this.radioProximoPaciente];
            this.fazerChamadaDialog(paciente);
        },

        proximoLocalPaciente() {
            // se encontrou nos idLocalMedico do primeiro exame
            if (this.idLocalMedico.indexOf(this.localEscolhido.idLocal) != -1) {
                this.mensagemProximoLocalDialog = this.localEscolhido.nomeLocal;
                this.dialogProximoAtendimento = true;
            }
            // se n encontrou nos idLocalMedico do primeiro exame
            else {
                var mensagemProximoLocalAux = [];
                this.mensagemAutomatico.forEach(
                    function (element, index) {
                        if (!element) {
                            mensagemProximoLocalAux.push(this.mensagemProximoLocal[index]);
                        }
                    }.bind(this)
                );
                this.mensagemProximoLocalDialog = mensagemProximoLocalAux.join(" ou ");
                this.dialogProximoAtendimento = true;
            }
        },

        voltar() {
            (this.ficha = {
                codigo: "",
                nomeEspecialidade: "",
                idAtendimento: "",
                idLocal: "",
                nomePaciente: "",
                status: ""
            }),
                (this.addedFicha = false);
            this.show = false;
            this.isEspera = false;
            this.fezChamada = false;
            this.emPacientePendente = false;
            this.isAtendimento = false;
            EventBus.$emit('showSideBar', true)
            EventBus.$emit('item-exit', true)
        },

        fecharDialogConsultasPaciente() {
            this.dialoConsultasPaciente = false;
            // this.listaConsultasPaciente = [];
        },

        refreshToken() {
            medicoService.medico
                .refreshToken(
                    getToken(),
                    this.localEscolhido.idLocal,
                    this.unidadeSelecionada.idUnidade
                )
                .then(rsp => {
                    console.log(rsp);
                    if (rsp.status == 200) {
                        setToken(rsp.data.token);
                        this.emRefreshToken = true;
                        this.socketAux = io.connect(socketService.SOCKET_URL, {
                            query: {
                                token: getToken()
                            }
                        });

                        let connected = new Promise(
                            function (resolve, reject) {
                                this.interval = setInterval(() => {
                                    if (this.socketAux.connected) {
                                        var self = this;
                                        if (self.socket) {
                                            self.socket.destroy();
                                            delete self.socket;
                                            self.socket = null;
                                        }
                                        this.socket = this.socketAux;
                                        resolve("connected");
                                    }
                                }, 100);
                            }.bind(this)
                        );

                        connected.then(
                            function (response) {
                                if (response == "connected") {
                                    clearInterval(this.interval);
                                    console.log("promisse", response);
                                    this.chamarSocket();
                                    this.adicionarServicos(true);
                                    this.organizarExames(); //adicionou agora..
                                }
                            }.bind(this)
                        );
                    }
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        getColor(data) {
            var color = "grey";
            if (data != null && data !== "" && !this.fezChamada) {
                color = "primary darken-3";
            }
            if (this.fezChamada && !this.isAtendimento) {
                color = "analogoD darken-2";
            }
            if (this.isAtendimento) {
                color = "primary";
            }
            return color;
        },

        timeDurationToString(duration) {
            return duration > 9 ? duration : "0" + duration;
        },

        chamarModalConexao() {
            console.log("em chamarModalConexao..");

            if (this.mensagemNotificacaoSocket == "aguardando conexao") {
                console.log("em if aguardando conex");
                this.aguardandoConexao = true;
            }
            if (this.mensagemNotificacaoSocket == "conectado") {
                this.aguardandoConexao = false;
            } else if (this.mensagemNotificacaoSocket == "desconectado") {
                this.aguardandoConexao = true;
            }
        },

        retornarLocais() {
            console.log("retornar servicos do medico..");
            medicoService.medico
                .retornarLocais()
                .then(rsp => {
                    console.log("rsp locais");
                    this.listaLocais = rsp.data;
                    //this.localEscolhido = localEscolhido[0];
                    console.log(this.listaLocais);
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        retornarServicosDoMedico() {
            medicoService.medico
                .retornarServicosDoMedico()
                .then(rsp => {
                    console.log("rsp retornarServicosDoMedico", rsp.data);
                    this.listaServicosDoMedico = this.normalizarServicosDoMedico(rsp.data);
                    this.agruparUnidade(this.listaServicosDoMedico);
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        normalizarServicosDoMedico(data) {
            if (!Array.isArray(data)) {
                return [];
            }

            if (data.length === 0) {
                return [];
            }

            if (!data[0].locais) {
                return data;
            }

            const servicosNormalizados = [];

            data.forEach(unidade => {
                const locais = Array.isArray(unidade.locais) ? unidade.locais : [];

                locais.forEach(local => {
                    const servicos = Array.isArray(local.servicos) ? local.servicos : [];

                    servicos.forEach(servico => {
                        servicosNormalizados.push({
                            idUnidade: unidade.idUnidade,
                            nomeUnidade: unidade.nomeUnidade,
                            idServico: servico.idServico,
                            idExameEspecialidade: servico.idExameEspecialidade,
                            nomeEspecialidade: servico.nomeEspecialidade,
                            idLocais: String(local.idLocal),
                            nomeLocais: local.nomeLocal || "",
                            exames: Array.isArray(servico.exames)
                                ? servico.exames.join(",")
                                : String(servico.exames || "")
                        });
                    });
                });
            });

            return servicosNormalizados;
        },

        retornarConsultasFinalizadas() {
            medicoService.medico
                .retornarConsultasFinalizadas(this.user.id, this.user.idUnidade)
                .then(rsp => {
                    console.log("rsp retornarConsultasFinalizadas", rsp.data);
                    // console.log("rsp retornarConsultasFinalizadas", rsp.data);
                    // alterar status para 4
                    for (let index = 0; index < rsp.data.length; index++) {
                        rsp.data[index].status = 4;
                    }
                    this.listaPacientesAtendidos = rsp.data;
                    this.organizarListasPacientesAtendidos(); 
                    
                    // this.dialoConsultasPaciente = true;
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        organizarListasPacientesAtendidos() {
            if (!this.listaPacientesAtendidos || !this.listaPacientesAtendidos.length) return
            var listaPacientesAux = [];
            var elementPrincipal = JSON.parse(JSON.stringify(this.listaPacientesAtendidos[0]));
            this.$set(elementPrincipal, "atendimentos", []);
            listaPacientesAux.push(elementPrincipal);
            for (let index = 1; index < this.listaPacientesAtendidos.length; index++) {
                const element = this.listaPacientesAtendidos[index];
                if (element.idAtendimento != elementPrincipal.idAtendimento) {
                    elementPrincipal = this.listaPacientesAtendidos[index];
                    this.$set(elementPrincipal, "atendimentos", []);
                    listaPacientesAux.push(elementPrincipal);
                } else {
                    elementPrincipal.atendimentos.push(element);
                }
            }
            this.listaPacientesAtendidos = listaPacientesAux;
            this.listaPacientesAtendidosFiltrada = listaPacientesAux;
            
        },

        agruparUnidade(data) {
            this.listaUnidades = [];
            if (data.length) {
                var unidadesAgrupadas = this.groupBy(data, "idUnidade");
                unidadesAgrupadas.forEach(element => {
                    var unidade = {
                        nomeUnidade: element[0].nomeUnidade,
                        idUnidade: element[0].idUnidade
                    };
                    this.listaUnidades.push(unidade);
                });
            }
        },

        agruparLocaisPorUnidade(unidade) {
            this.listaLocais = [];
            this.localEscolhido = "";
            this.listaServicos = [];
            this.listaServicosSelecionados = ""; // added
            if (unidade != undefined) {
                var listaServicos = JSON.parse(
                    JSON.stringify(this.listaServicosDoMedico)
                );
                var retorno = listaServicos.filter(
                    element => element.idUnidade == unidade.idUnidade
                );
                retorno.forEach(elementRetorno => {
                    if (!elementRetorno.idLocais || !elementRetorno.nomeLocais) {
                        return;
                    }

                    const nomeLocais = String(elementRetorno.nomeLocais).split(",");
                    const idLocais = String(elementRetorno.idLocais).split(",");

                    idLocais.forEach((element, index) => {
                        var local = {
                            idLocal: element,
                            nomeLocal: nomeLocais[index] || "",
                            idUnidade: elementRetorno.idUnidade
                        };
                        this.listaLocais.findIndex(
                            element => element.idLocal == local.idLocal
                        ) == -1 ?
                            this.listaLocais.push(local) :
                            "";
                    });
                });
            } else {
                this.listaLocais = [];
            }
        },

        agruparServicosPorLocal(local) {
            this.listaServicos = [];
            this.listaServicosSelecionados = "";
            if (local != undefined) {
                var listaServicos = JSON.parse(
                    JSON.stringify(this.listaServicosDoMedico)
                );
                var retorno = listaServicos.filter(
                    element => element.idUnidade == local.idUnidade
                );

                retorno.forEach(elementRetorno => {
                    if (!elementRetorno.idLocais || !elementRetorno.exames) {
                        return;
                    }

                    const idLocais = String(elementRetorno.idLocais).split(",");
                    const exames = String(elementRetorno.exames).split(",");
                    var servico = {
                        idServico: elementRetorno.idServico,
                        nomeEspecialidade: elementRetorno.nomeEspecialidade,
                        exames: exames
                    };
                    idLocais.find(element => element == local.idLocal) ==
                        undefined ?
                        "" :
                        this.listaServicos.push(servico);
                });
            } else {
                this.listaServicos = [];
            }
        },

        validateField() {
            //this.$refs.form.validate();
        },
        listarCredenciaisAtendimento() {
            this.listaDeCredenciais = []
            medicoService.medico.listarCredenciaisAtendimento(this.user.id).then(r => {
                if (r.status == 200) {
                    this.listaDeCredenciais = r.data
                    this.addNew = this.listaDeCredenciais.length === 0
                }
            })
        },
        cadastrarCredenciaisAtendimento() {
            if (this.$refs.form.validate()) {
                const credenciais = {
                    id: this.selectedCard,
                    idUsuario: this.user.id,
                    unidade: this.unidadeSelecionada,
                    local: this.localEscolhido,
                    servicos: this.listaServicosSelecionados,
                    consultorio: this.descricaoLocal,
                    localConsultorio: this.nomeConsultorio
                }
                medicoService.medico.cadastrarCredenciaisAtendimento(credenciais).then(r => {
                    if (r.status == 200) {
                        if (r.data.status === 'success') {
                            this.adicionarServicosParaAtendimento()
                        }
                    }vertificarExameMedico
                    vertificarExameMedico
                })
            }
        },
        adicionarServicosParaAtendimento() {
            if (this.$refs.form.validate() || !this.addNew) {
                this.load = true
                this.addNew = true
                
                
                this.listaServicosEscolhidos = JSON.parse(
                    JSON.stringify(this.listaServicosSelecionados)
                ); // add 20/03
                console.log('passou: :', this.listaServicosEscolhidos);
                this.$store.dispatch(
                    "ServicosEscolhidos",
                    this.listaServicosEscolhidos
                );

                this.listaServicos.forEach(element => {
                    element.disponivel = false;
                });
                this.salvarConfiguracaoFilaMedica()
                this.listaServicos.forEach(item => {
                    for (
                        let index = 0; index < this.listaServicosSelecionados.length; index++
                    ) {
                        if (
                            this.listaServicosSelecionados[index].idServico == item.idServico
                        ) {
                            item.disponivel = true;
                        }
                    }
                });

                this.listaServicosDisponibilidade[0] = this.listaServicos[0];
                this.listaServicos.forEach(item => {
                    this.vertificarServicoExiste(item);
                });

                this.nomeConsultorioCompleto =
                    this.descricaoLocal.valor + this.nomeConsultorio;
                this.verificarLocalAutomatico(this.localEscolhido.idLocal);
                this.refreshToken();
                this.load = false
            }
        },

        salvarConfiguracaoFilaMedica() {
            const config = {
                idLocal: this.localEscolhido.idLocal,
                idEmpresa: this.user.idEmpresa,
                nome: this.user.nome,
                idUnidade: this.unidadeSelecionada.idUnidade,
                idUsuario: this.user.id,
                nomeConsultorio: this.nomeConsultorio,
                descricaoLocal: this.descricaoLocal.valor,
                status: 'online',
                servicos: this.listaServicosSelecionados
            }
            filaMedicaServise.filaMedica.cadastrarFilaMedica(config)
                .then(rsp => {
                    if (rsp.status == 200) {
                       // this.$router.push({ name: 'HomeMedico' })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },

        vertificarServicoExiste(item) {
            var x = 0;
            this.listaServicosDisponibilidade.forEach(item2 => {
                if (item2.idServico == item.idServico) {
                    x = 1;
                    return true;
                }
            });
            if (x == 0) {
                this.listaServicosDisponibilidade.push(item);
            }
            return false;
        },

        organizarExames() {
            // metodo para adicionar os exames a cadas servico da lista de servicos

            var listaServicosSelecionadosAux = [];
            this.listaServicosSelecionados.forEach(
                function (item, index) {
                    listaServicosSelecionadosAux[item.idServico] = item;
                }.bind(this)
            );

            listaServicosSelecionadosAux.forEach(element => {
                element.examesIndexados = [];
                element.exames.forEach(exame => {
                    element.examesIndexados[exame] = exame;
                });
            });

            this.listaServicosSelecionados = listaServicosSelecionadosAux;

            var nomeConsultorioServicos = {
                nomeConsultorio: this.descricaoLocal.valor + this.nomeConsultorio,
                servicos: this.listaServicosSelecionados
            };

            this.nomeConsultorioCompleto =
                this.descricaoLocal.valor + this.nomeConsultorio;

            this.$store.dispatch("NomeConsultorioServicos", nomeConsultorioServicos);
            this.$store.dispatch("LocalEscolhido", this.localEscolhido);
            this.$store.dispatch(
                "ServicosDisponibilidade",
                this.listaServicosDisponibilidade
            );
        },

        adicionarServicos(primeiroAcesso) {
            console.log("em adiconar servicos...");
            console.log(
                "lista serv disponibilidade",
                this.listaServicosDisponibilidade
            );

            medicoService.medico
                .disponibilizarServicos(
                    this.listaServicosDisponibilidade,
                    this.user.nome,
                    primeiroAcesso,
                    this.localEscolhido.nomeLocal,
                    this.nomeConsultorioCompleto,
                    this.user.tecnico
                )
                .then(rsp => {
                    console.log("servicos adicionados...");
                    if (rsp.data == true) {
                        this.mostrarTelaPrincipal = true;
                        this.nomeConsultorio = this.user.nomeConsultorioServicos.nomeConsultorio; // added here
                        this.retornarPacientesDisponiveis(primeiroAcesso);
                    }
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        limparIntervalos() {
            console.log("limpar intervalos");
            this.intervalos.forEach(clearInterval);
        },
        adiconarAtendimentoEmEspera() {
            if (!this.blockMethod) {
                EventBus.$emit('showSideBar', true)
                EventBus.$emit('item-exit', true)
                this.blockMethod = true;

                medicoService.medico
                    .atendimentoEmEspera(this.ficha.idAtendimento)
                    .then(rsp => {
                        if (rsp.data && rsp.data.success) {
                            var copiaFicha = JSON.parse(JSON.stringify(this.ficha));
                            this.listaPacientesEspera.push(copiaFicha)
                            this.listaPacientesEsperaFiltrada.push(copiaFicha)
                            this.seconds = 0 * 60;
                            (this.tempoAtendimento = "00:00:00"), this.limparIntervalos();
                            this.textCronometroRegressivo = "[00:40]";
                            this.show = false;
                            this.isEspera = false;
                            this.fezChamada = false;
                            this.isAtendimento = false;
                            this.addedFicha = false;
                            this.nChamada = 0;
                            //(this.isPendentes = false),
                            this.iniciouAtendimento = false;
                            (this.ficha.senha = ""),
                                (this.ficha.codigo = ""),
                                (this.ficha.nomeEspecialidade = ""),
                                (this.ficha.nomePaciente = ""),
                                (this.ficha.idAtendimento = ""),
                                (this.ficha.idLocal = "");
                            this.blockMethod = false;
                        }
                    })
                    .catch(err => {
                        // handle your error here
                        this.blockMethod = false;
                        console.log(err);
                    });
            }
            this.alertEspera = false;
        },
        atendimentoEmEspera() {
            this.alertEspera = true;
        },
        retornarConsultasPaciente(tipo) {
            if (tipo == 1) {
                this.dialoConsultasPaciente = true;
            } else {
                if (!this.blockMethod) {
                    this.blockMethod = true;
                    medicoService.medico
                        .retornarConsultasPaciente(this.ficha.idAtendimento, this.ficha.idServico)
                        .then(rsp => {
                            console.log("retornar consultas paciente", rsp.data);
                            
                            this.listaConsultasPaciente = rsp.data;
                            this.listaConsultasPaciente.forEach(consulta => {
                                consulta.files = []
                                if (consulta.status == 0) {
                                    if (!this.vertificarExameMedico(consulta)) {
                                        consulta.colorText = "grey--text text--lighten-1"
                                        consulta.cor = "grey lighten-1";
                                        consulta.status = false;
                                        consulta.showCheck = false;
                                    } else {
                                        consulta.cor = "";
                                        consulta.status = false;
                                        consulta.showCheck = true;
                                    }
                                } else if (consulta.status == 1) {
                                    if (!this.vertificarExameMedico(consulta)) {
                                        consulta.colorText = "grey--text text--lighten-1"
                                        consulta.cor = "grey lighten-1";
                                        consulta.status = false;
                                        consulta.showCheck = false;
                                    } else {
                                        consulta.contador = "";
                                        consulta.status = false; // 0, 1, 2 -> padrão da consulta / cores
                                        consulta.showCheck = true;
                                    }
                                } else if (consulta.status == 2) {
                                    if (!this.vertificarExameMedico(consulta)) {
                                        consulta.colorText = "grey--text text--lighten-1"
                                        consulta.cor = "grey lighten-1";
                                        consulta.status = false;
                                        consulta.showCheck = false;
                                    } else {
                                        consulta.colorText = "teal--text text--lighten-4"
                                        consulta.cor = "teal lighten-2";
                                        consulta.status = false;
                                        consulta.showCheck = false;
                                    }
                                }
                            })
                            this.listaConsultasPacienteAgrupada = this.groupBy(
                                this.listaConsultasPaciente,
                                "idUnidade"
                            );
                            
                            this.blockMethod = false;
                        }).finally(() => {
                            this.blockMethod = false;
                            if(this.isAtendidos) {
                                this.iniciarAtendimento();                                
                            }
                            
                        })
                        .catch(err => {
                            // handle your error here
                            this.blockMethod = false;
                            console.log(err);
                        })
                }
            }
        },
        cadastrarProntuario(listaConsultas) {
            var prescricoes = []
            var prontuarios = this.$store.getters.prontuario
            var prontuario = null
            var indexProntuario = null
            for (let i = 0; i < prontuarios.length; i++) {
                const p = prontuarios[i];
                if (p.idAtendimento == this.ficha.idAtendimento) {
                    prontuario = p
                    indexProntuario = i
                }
            }

            if (prontuario != null) {
                this.receita = []
                // console.log(this.receita)
                /* if (this.receita != null && this.receita.length > 0) {
                    this.receita.forEach(r => {
                        var horarios = []
                        r.prescricao.forEach(p => {
                            horarios.push(p.idTipoHorarioPrescricao)
                        })
                        prescricoes.push({
                            idMedicamento: r.idMedicamento,
                            idHorarios: horarios,
                            obs: r.obs
                        })
                    })
                } */
                var examesSolicitacao = []
                // console.log('prontuario.solicitacoes: ', prontuario.solicitacoes);

                if (prontuario.solicitacoes != null && prontuario.solicitacoes.length > 0) {
                    prontuario.solicitacoes.forEach(solicitacao => {
                        // Verifica se "items" existe e é um array
                        if (Array.isArray(solicitacao.items)) {
                            solicitacao.items.forEach(function (item) {
                                examesSolicitacao.push({
                                    'idExame': item.idExame !== undefined ? item.idExame : null,
                                    'idExameMedicoSolicitacao': item.id !== undefined ? item.id : null
                                });
                            });
                        }
                    });
                }
                if (prontuario.solicitacoesLaboratorio != null && prontuario.solicitacoesLaboratorio.length > 0) {
                    prontuario.solicitacoesLaboratorio.forEach(solicitacao => {
                        // Verifica se "items" existe e é um array
                        if (Array.isArray(solicitacao.items)) {
                            solicitacao.items.forEach(item => {
                                examesSolicitacao.push({
                                    'idExame': item.idExame !== undefined ? item.idExame : null,
                                    'idExameMedicoSolicitacao': item.id !== undefined ? item.id : null
                                });
                            });
                        }
                    });
                }

                let consultas = []
                listaConsultas.forEach(c => {
                    consultas.push({
                        idConsulta: c.idConsulta
                    })
                })
                const idExamesOSResolvido = this.ficha.idExamesos || listaConsultas
                    .map(c => c.idexamesos)
                    .find(idExamesos => idExamesos != null && idExamesos !== '')

                this.ficha.idExamesos = idExamesOSResolvido || this.ficha.idExamesos
                var data = {
                    idPaciente: this.ficha.idPaciente,
                    idUsuario: this.user.id,
                    idEmpresa: this.user.idEmpresa,
                    idUnidade: this.user.idUnidade,
                    idExamesOS: idExamesOSResolvido || null,
                    idAtendimento: this.ficha.idAtendimento,
                    consultas: consultas,
                    laudo: {
                        descricao: prontuario.conteudoLaudo
                    },
                    prontuario: {
                        descricao: prontuario.conteudoProntuario
                    },
                    prescricoes: [],
                    examesSolicitacao: examesSolicitacao
                }
                console.log('-- -- ==', data, this.solicitacao)
                medicoService.medico.cadastrarProntuario(data).then(r => {
                    console.log(r.status);
                }).finally(() => {
                    prontuarios.splice(indexProntuario, 1)
                    this.$store.dispatch('updateProntuario', [{
                        idAtendimento: '',
                        conteudoLaudo: '',
                        conteudoProntuario: ''
                    }])
                })
            }
        },

        encerrarAtendimento() {
          
            if (!this.blockMethod) {
                this.blockMethod = true
                console.log('0----- :', this.listaConsultasPaciente[0], this.listaConsultasPaciente);
                
                var dataChegada = this.listaConsultasPaciente[0].dataChegada
                var listaConsultasFiltrada = this.listaConsultasPaciente.filter(
                    exame => {
                        return exame.status == true
                    }
                );
                
                if (listaConsultasFiltrada.length == 0) {
                    this.dialogNaoExecutouExame = true;
                    this.blockMethod = false;
                    return;
                }
                this.loadFinalizar = true

                EventBus.$emit('encerrarVoucher', true)
                EventBus.$emit('item-exit', true)

                medicoService.medico
                    .encerrarAtendimento(
                        this.user.id,
                        this.user.idUnidade,
                        this.ficha.idAtendimento,
                        this.ficha.idConsulta,
                        listaConsultasFiltrada,
                        dataChegada,
                        this.nomeConsultorioCompleto,
                        !this.user.tecnico,
                        this.ficha.idExamesos,
                        this.ficha.idOrdemServico
                    )
                    .then(rsp => {
                        // console.log(rsp.data)

                        console.log("rsp encerrarAtendimento:", rsp.data);
                        this.dialoConsultasPaciente = false;
                        if (!this.user.tecnico) {
                            var dadosProntuario = this.$store.getters.prontuario
                            if (dadosProntuario.length > 0) {
                                var index = null
                                for (let i = 0; i < dadosProntuario.length; i++) {
                                    const d = dadosProntuario[i];
                                    if (this.ficha.idAtendimento == d.idAtendimento) {
                                        index = i
                                        break
                                    }
                                }
                                if (index) {
                                    dadosProntuario.splice(index, 1)
                                }
                            }

                            this.cadastrarProntuario(listaConsultasFiltrada)

                        }
                        console.log("encerrarAtendimento rsp.data:", rsp.data);
                        
                        if (rsp.data == true) {

                            this.possuiProximoAtendimento = false;
                            this.mensagemCabecalhoProximoAtendimento =
                                "O Paciente não possui próximos atendimentos";
                            this.mensagemProximoServico =
                                "O Paciente não possui próximos atendimentos";
                            this.mensagemProximoLocal = "Não há";
                            this.mensagemProximoExame = "Não há";
                        } else {
                            this.consultas = JSON.parse(JSON.stringify(rsp.data));
                            const primeiraConsulta = Array.isArray(rsp.data) ? rsp.data[0] : null;

                            this.possuiProximoAtendimento = true;
                            this.mensagemCabecalhoProximoAtendimento =
                                "Por favor, Solicite que o Paciente dirija-se ao próximo atendimento.";
                            this.mensagemIdProximaUnidade = primeiraConsulta ? primeiraConsulta.idUnidade : "";
                            this.mensagemProximoServico = primeiraConsulta ? primeiraConsulta.nomeEspecialidade : "";
                            this.mensagemProximoExame = primeiraConsulta ? primeiraConsulta.nomeExame : "";
                            this.mensagemAutomatico = this.parseCsv(primeiraConsulta ? primeiraConsulta.automatico : "")
                                .map(x => +x);
                            this.mensagemProximoLocal = this.parseCsv(primeiraConsulta ? primeiraConsulta.nomeLocal : "");
                            this.idLocalMedico = this.parseCsv(primeiraConsulta ? primeiraConsulta.idLocalMedico : "");
                            this.mensagemProximaUnidade = primeiraConsulta ? primeiraConsulta.nomeUnidade : "";
                            this.proximoLocalPaciente();
                        }

                        this.seconds = 0 * 60;
                        (this.tempoAtendimento = "00:00:00"), this.limparIntervalos();
                        this.textCronometroRegressivo = "[00:40]";
                        this.show = false;
                        this.dialogProximoAtendimento = true;
                        this.fezChamada = false;
                        this.isEspera = false;
                        this.addedFicha = false; // add
                        this.isAtendimento = false;
                        this.nChamada = 0;
                        // (this.isPendentes = false),
                        this.iniciouAtendimento = false;
                        (this.ficha.senha = ""),
                            (this.ficha.codigo = ""),
                            (this.ficha.nomeEspecialidade = ""),
                            (this.ficha.nomePaciente = ""),
                            (this.ficha.idAtendimento = ""),
                            (this.ficha.idLocal = "");
                        this.exibirListaPendentes();
                        this.blockMethod = false;
                        EventBus.$emit('showSideBar', true)
                    }).finally(() => {
                        this.loadFinalizar = false;
                        this.retornarConsultasFinalizadas()
                        })
                    .catch(err => {
                        // handle your error here
                        console.log(err);

                        this.blockMethod = false;
                    })
            }
        },
        gerarVoucher(tipoSolicitacao, exames) {

            posAtendimentoService.gerarVoucher({
                exames: exames, // A variável exames deve ser definida de forma apropriada
                idEmpresa: this.user.idEmpresa,
                idUnidadeNegocio: this.user.idUnidade,
                tipoSolicitacao: tipoSolicitacao, // Define o tipo de solicitação aqui
                idPaciente: this.mFicha.idPaciente,
                idPrestadorSolicitante: this.user.idPrestador, // id do médico
                idUsuario: this.user.id,
                armazenado: false,
                obs: ""
            }).then(r => {
                console.log(r.data);
            })
            },
        toggle(index) {
            const i = this.selected.indexOf(index);
            if (i > -1) {
                this.selected.splice(i, 1);
            } else {
                this.selected.push(index);
            }
        },

        filtrarAtendimentosMedico(atendimentos) {
            if (atendimentos != null && atendimentos.length > 0) {
                var atendimentosAux = atendimentos.filter(atendimento => {
                    var isLocal = false
                    console.log('idLocalFixo', atendimento.idLocalFixo);
                    console.log('idMedico', this.user.idLocal);
                    console.log(atendimento.idLocalFixo == this.user.idLocal);
                    if (atendimento.idLocalFixo == null || atendimento.idLocalFixo == this.user.idLocal) {
                        isLocal = true
                    }
                    if (isLocal) {
                        if (
                            atendimento.idMedico == null ||
                            atendimento.idMedico == this.user.id
                        ) {
                            if (this.listaServicosSelecionados[atendimento.idServico] != null) {
                                if (
                                    this.listaServicosSelecionados[atendimento.idServico]
                                        .examesIndexados[atendimento.idExame] != null
                                ) {
                                    console.log("verificarAtendimentos true!!");
                                    return true;
                                }
                            }
                        }
                    }
                });
                return atendimentosAux;

            } else return false
        },

        verificarAtendimentos(atendimentos) {
            // verifica se medico atende um dos atendimentos
            var encontrou = false;
            atendimentos.forEach(
                function (atendimento, index, object) {
                    console.log("atendimento", atendimento);
                    if (
                        atendimento.idMedico == null ||
                        atendimento.idMedico == this.user.id
                    ) {
                        if (this.listaServicosSelecionados[atendimento.idServico] != null) {
                            if (
                                this.listaServicosSelecionados[atendimento.idServico]
                                    .examesIndexados[atendimento.idExame] != null
                            ) {
                                console.log("verificarAtendimentos true!!");
                                encontrou = true;
                            }
                        }
                    }
                }.bind(this)
            );

            if (encontrou) {
                return true;
            } else {
                return false;
            }
        },

        chamarSocket() {
            this.socket.on(
                "atendido",
                function (mensagem) {
                    console.log("skt atendido:", JSON.parse(JSON.stringify(mensagem)));
                    var atendimentosFiltrados = this.filtrarAtendimentosMedico(mensagem);
                    if (atendimentosFiltrados.length) {
                        var atendimento = this.formatarAtendimentosTabela(
                            atendimentosFiltrados
                        );

                        if (atendimento.atendimentoApoio == 1) { // Bugado
                            var indexFinded = this.listaPacientesDisponiveis.findIndex(
                                element => element.dataStatus > atendimento.dataStatus
                            );
                            console.log("indexFinded", indexFinded);
                            if (indexFinded == -1) {
                                this.listaPacientesDisponiveis.push(atendimento);
                            } else if (indexFinded < 3) {
                                this.listaPacientesDisponiveis.splice(3, 0, atendimento);
                            } else {
                                this.listaPacientesDisponiveis.splice(
                                    indexFinded,
                                    0,
                                    atendimento
                                );
                            }
                        } else {
                            if (mensagem.status == 1 || typeof mensagem.status === 'undefined') {
                                console.log(mensagem.status, '1');
                                var indexFinded = this.listaPacientesDisponiveis.findIndex(
                                    element => element.dataFinalAtendimento > atendimento.dataFinalAtendimento);

                                console.log("else indexFinded", indexFinded);
                                if (indexFinded == -1) {
                                    this.listaPacientesDisponiveis.push(atendimento);
                                } else {
                                    this.listaPacientesDisponiveis.splice(
                                        indexFinded,
                                        0,
                                        atendimento
                                    );
                                }
                            }
                            if (mensagem.status == 2 || mensagem.status == 4) {
                                console.log(mensagem.status, '2 || 4');

                                var indexFinded = this.listaPacientesPendente.findIndex(
                                    element => element.dataFinalAtendimento > atendimento.dataFinalAtendimento);

                                console.log("else indexFinded", indexFinded);
                                if (indexFinded == -1) {
                                    this.listaPacientesPendente.push(atendimento);
                                } else {
                                    this.listaPacientesPendente.splice(
                                        indexFinded,
                                        0,
                                        atendimento
                                    );
                                }
                            }
                            if (mensagem.status == 3) {
                                console.log(mensagem.status, '3');

                                var indexFinded = this.listaPacientesEspera.findIndex(
                                    element => element.dataFinalAtendimento > atendimento.dataFinalAtendimento);

                                console.log("else indexFinded", indexFinded);
                                if (indexFinded == -1) {
                                    this.listaPacientesEspera.push(atendimento);
                                } else {
                                    this.listaPacientesEspera.splice(
                                        indexFinded,
                                        0,
                                        atendimento
                                    );
                                }
                            }
                        }
                    }
                }.bind(this)
            );

            this.socket.on(
                "removerPaciente",
                function (mensagem) {
                    console.log("removerPaciente:", JSON.parse(JSON.stringify(mensagem)));
                    var idAtendimento = mensagem.idAtendimento

                    var indexDisponiveis = null
                    for (let i = 0; i < this.listaPacientesDisponiveis.length; i++) {
                        const paciente = this.listaPacientesDisponiveis[i]
                        if (paciente.idAtendimento == idAtendimento) {
                            indexDisponiveis = i
                            break
                        }
                    }

                    var indexPendente = null
                    for (let i = 0; i < this.listaPacientesPendente.length; i++) {
                        const paciente = this.listaPacientesPendente[i]
                        if (paciente.idAtendimento == idAtendimento) {
                            indexPendente = i
                            break
                        }
                    }

                    var indexEspera = null
                    for (let i = 0; i < this.listaPacientesEspera.length; i++) {
                        const paciente = this.listaPacientesEspera[i]
                        if (paciente.idAtendimento == idAtendimento) {
                            indexEspera = i
                            break
                        }
                    }
                    // console.log('--------', indexDisponiveis, indexPendente, indexEspera);
                    if (indexDisponiveis != null) {
                        this.listaPacientesDisponiveis.splice(indexDisponiveis, 1)
                    }
                    if (indexPendente != null) {
                        this.listaPacientesPendente.splice(indexPendente, 1)
                    }
                    if (indexEspera != null) {
                        this.listaPacientesEspera.splice(indexEspera, 1)
                    }

                }.bind(this)
            );
            /**
             * 
             */
            this.socket.on(
                "chamandoPaciente",
                function (mensagem) {
                    console.log("skt chamandoPaciente:", mensagem);
                    this.listaPacientesDisponiveis.forEach((element, index) => {
                        if (element.idAtendimento == mensagem.idAtendimento) {
                            if (!mensagem.automatico) {
                                //remove normal
                                this.listaPacientesDisponiveis.splice(index, 1);
                            } else {
                                // marca e n exclui
                                // mensagem.idLocal == local do médico que enviou o socket
                                if (mensagem.idLocal == this.localEscolhido.idLocal) {
                                    element.idLocalAutomatico = this.localEscolhido.idLocal;
                                } else {
                                    this.listaPacientesDisponiveis.splice(index, 1);
                                }
                            }
                        }
                    });

                    this.listaPacientesPendente.forEach((element, index) => {
                        if (element.idAtendimento == mensagem.idAtendimento) {
                            this.listaPacientesPendente.splice(index, 1); //remover
                        }
                    });
                }.bind(this)
            );

            this.socket.on(
                "connect",
                function (mensagem) {
                    this.mensagemNotificacaoSocket = "conectado";
                    this.chamarModalConexao();
                    // chamar talvez aqui
                }.bind(this)
            );

            this.socket.on("connect_error", () => {
                this.mensagemNotificacaoSocket = "aguardando conexao";
                this.chamarModalConexao();
            });

            this.socket.on(
                "disconnect",
                function () {
                    this.mensagemNotificacaoSocket = "desconectado";
                    this.chamarModalConexao();
                }.bind(this)
            );
        },
        //ok
        retornarPacientesDisponiveis(primeiroAcesso) {
            // this.retornarConsultasFinalizadas()
            medicoService.medico
                .retornarPacientesDisponiveis(
                    this.listaServicosEscolhidos,
                    primeiroAcesso,
                    this.localEscolhido.nomeLocal,
                    this.user.tecnico
                )
                .then(rsp => {
                    console.log(
                        "rsp retornarPacientesDisponiveis:",
                        JSON.parse(JSON.stringify(rsp.data))
                    );
                    if (rsp.data != false) {
                        this.listaPacientes = this.listaPacientes.concat(rsp.data);
                    }
                    if (this.listaPacientes.length) {
                        this.organizarListasPacientes();
                    }
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        formatarAtendimentosTabela(atendimento) {
            var atendimentoAux = atendimento[0];
            this.$set(atendimentoAux, "atendimentos", []);
            for (let index = 1; index < atendimento.length; index++) {
                const element = atendimento[index];
                atendimentoAux.atendimentos.push(element);
            }
            return atendimentoAux;
        },

        formatarEnvioAtendimento(atendimento) {
            var atendimentoAux = [];
            atendimentoAux.push(JSON.parse(JSON.stringify(atendimento)));
            atendimento.atendimentos.forEach(element => {
                atendimentoAux.push(element);
            });
            delete atendimentoAux[0].atendimentos;
            return atendimentoAux;
        },

        organizarListasPacientes() {
            var listaPacientesAux = [];
            var elementPrincipal = JSON.parse(JSON.stringify(this.listaPacientes[0]));
            this.$set(elementPrincipal, "atendimentos", []);
            listaPacientesAux.push(elementPrincipal);
            for (let index = 1; index < this.listaPacientes.length; index++) {
                const element = this.listaPacientes[index];
                if (element.idAtendimento != elementPrincipal.idAtendimento) {
                    elementPrincipal = this.listaPacientes[index];
                    this.$set(elementPrincipal, "atendimentos", []);
                    listaPacientesAux.push(elementPrincipal);
                } else {
                    elementPrincipal.atendimentos.push(element);
                }
            }
            this.listaPacientes = listaPacientesAux;
            this.adicionarPacientesAFilas();
        },

        adicionarPacientesAFilas() {
            this.listaPacientes.forEach(element => {
                if (element.status == 1) {
                    this.listaPacientesDisponiveis.push(element);
                    element.jaChamado = false;
                } else if (element.status == 2 || element.status == 4) {
                    this.listaPacientesPendente.push(element);
                } else if (element.status == 3) {
                    var serverDate = new Date(element.dataStatus);
                    element.dataStatusCronometro = serverDate.getTime();
                    this.listaPacientesEspera.push(element);
                }
            });
        },

        addFicha(item) {
            if (item.status == 2 || item.status == 4) {
                this.fezChamada = true;
                this.emPacientePendente = true;
            } else {
                this.fezChamada = false;
            }

            (this.addedFicha = true), (this.iniciouAtendimento = false);
            this.ficha.codigo = item.codigo;
            this.ficha.idAtendimento = item.idAtendimento;
            this.ficha.idLocal = item.idLocal;
            this.ficha.idPaciente = item.idPaciente;
            this.ficha.idExamesos = item.idExamesos;
            this.ficha.idLocalMedico = item.idLocalMedico;
            this.ficha.idServico = item.idServico;
            this.ficha.nomePaciente = item.nomePaciente;
            this.ficha.idade = this.calcularIdade(item.dataNascimento).idade;
            this.ficha.dataNascimento = item.dataNascimento;
            this.ficha.nomeEspecialidade = item.nomeEspecialidade;
            this.ficha.status = item.status;
            this.ficha.dataStatus = item.dataStatus;
            this.ficha.dataFinalAtendimento = item.dataFinalAtendimento;
            this.ficha.idExame = item.idExame;
            this.ficha.prioridade = item.prioridade;
            this.ficha.idConsulta = item.idConsulta;
            this.ficha.nomeExame = item.nomeExame;
            this.ficha.idOrdemServico = item.idOrdemServico;
            this.ficha.atendimentos = item.atendimentos;
            console.log("ficha", this.ficha);
            this.retornarConsultasPaciente(2)
             //console.log('formatar',this.formatarEnvioAtendimento(this.ficha));
        },

        addFichaEspera(item) {
            this.isEspera = true;
            (this.addedFicha = true), (this.emPacienteEspera = true);
            this.fezChamada = false;
            this.iniciouAtendimento = false;
            this.ficha.codigo = item.codigo;
            this.ficha.idAtendimento = item.idAtendimento;
            this.ficha.idLocal = item.idLocal;
            this.ficha.idPaciente = item.idPaciente;
            this.ficha.idServico = item.idServico;
            this.ficha.dataNascimento = item.dataNascimento;
            this.ficha.idade = this.calcularIdade(item.dataNascimento).idade;
            this.ficha.nomeExame = item.nomeExame;
            this.ficha.nomePaciente = item.nomePaciente;
            this.ficha.idExamesos = item.idExamesos;
            this.ficha.nomeEspecialidade = item.nomeEspecialidade;
            this.ficha.status = item.status;
            this.ficha.dataStatus = item.dataStatus;
            this.ficha.dataFinalAtendimento = item.dataFinalAtendimento;
            this.ficha.dataStatusCronometro = item.dataStatusCronometro; // added b me
            this.ficha.idExame = item.idExame;
            this.ficha.prioridade = item.prioridade;
            this.ficha.idConsulta = item.idConsulta;
            this.ficha.idOrdemServico = item.idOrdemServico;
            this.ficha.atendimentos = item.atendimentos;
            this.retornarConsultasPaciente(2)
             console.log("ficha espera", this.ficha);
        },

        addFichaAtendidos(item) {
            this.loadAtendidos = true;
            this.isAtendidos = true;           
            this.addedFicha = true
            this.fezChamada = false;
            this.iniciouAtendimento = false;
            this.ficha.codigo = item.codigo;
            this.ficha.idAtendimento = item.idAtendimento;
            this.ficha.idLocal = item.idLocal;
            this.ficha.idPaciente = item.idPaciente;
            this.ficha.idServico = item.idServico;
            this.ficha.dataNascimento = item.dataNascimento;
            this.ficha.idade = this.calcularIdade(item.dataNascimento).idade;
            this.ficha.nomeExame = item.nomeExame;
            this.ficha.nomePaciente = item.nomePaciente;
            this.ficha.nomeEspecialidade = item.nomeEspecialidade;
            this.ficha.status = item.status;
            this.ficha.dataStatus = item.dataStatus;
            this.ficha.dataFinalAtendimento = item.dataFinalAtendimento;
            this.ficha.dataStatusCronometro = item.dataStatusCronometro; // added b me
            this.ficha.idExame = item.idExame;
            this.ficha.prioridade = item.prioridade;
            this.ficha.idConsulta = item.idConsulta;
            this.ficha.idOrdemServico = item.idOrdemServico;
            this.ficha.atendimentos = []
            this.ficha.idMedico = item.idMedico
            this.ficha.idExamesos = item.idExamesos
            this.ficha.idProntuario = item.idProntuario
            this.ficha.idLaudo = item.idLaudo
            this.ficha.idServico = item.idServico

            this.retornarConsultasPaciente(2)            
            console.log("ficha atendidos", this.ficha);
        },

        converterHorarioStatus(status) {
            var convertido = new Date(status).getTime();
            return convertido;
        },

        chamarModalNaoCompareceu() {
            this.dialogNaoCompareceu = true;
        },

        reiniciarAtendimento() {
            this.iniciouAtendimento = true;
            this.fezChamada = true;
            this.isAtendimento = true;

            for (let index = 0; index < this.listaPacientesEspera.length; index++) {
                if (
                    this.listaPacientesEspera[index].idAtendimento ==
                    this.ficha.idAtendimento
                ) {
                    this.listaPacientesEspera.splice(index, 1);
                }
            }
            var dataFicha = this.ficha.dataStatusCronometro;
            var dataAgora = new Date().getTime();
            var segundos = new Date(dataAgora - dataFicha) / 1000;
            this.seconds = Math.trunc(segundos);
            EventBus.$emit('showSideBar', false)
            this.chamarCronometro();
        },

        iniciarAtendimento() {

            if (!this.blockMethod) {
                this.blockMethod = true;

                this.isAtendimento = true;
                this.emPacientePendente = false;
                EventBus.$emit('showSideBar', false)
                medicoService.medico
                    .iniciarAtendimento(
                        this.ficha.idAtendimento,
                        this.ficha.codigo,
                        this.ficha.idConsulta
                    )
                    .then(rsp => {
                        console.log("rsp iniciarAtendimento:", rsp);
                        // console.log('----------',rsp.data != 'false')
                        if (rsp.status == 200 && rsp.data) {
                            for (
                                let index = 0; index < this.listaPacientesPendente.length; index++
                            ) {
                                if (
                                    this.listaPacientesPendente[index].idAtendimento ==
                                    this.ficha.idAtendimento
                                ) {
                                    this.listaPacientesPendente.splice(index, 1);
                                }
                            }
                            this.habilitarBotaoCronometro = false;
                            clearInterval(this.intervalContagemRegressiva);
                            this.intervalContagemRegressiva = "";                           
                            this.ficha.dataStatusCronometro = new Date().getTime();
                            this.chamarCronometro();
                            this.blockMethod = false;
                            this.chamadaAutomatica();                          
                            this.iniciouAtendimento = true;  
                        }
                    }).finally( () => {
                        if(this.isAtendidos) {
                            this.loadAtendidos = false
                        }
                    })
                    .catch(err => {
                        // handle your error here
                        console.log(err);
                        this.blockMethod = false;
                    });
            }
        },

        adicionarListaPendente(fichaAux) {
            fichaAux.status = 4;
            var indexFinded = this.listaPacientesPendente.findIndex(
                element => element.dataFinalAtendimento > fichaAux.dataFinalAtendimento
            );
            if (indexFinded == -1) {
                this.listaPacientesPendente.push(fichaAux);
            } else {
                this.listaPacientesPendente.splice(indexFinded, 0, fichaAux);
            }
        },
        calcularIdade(dataNascimento) {
            let hoje = new Date();
            let nascimento = new Date(dataNascimento);
            let idade = hoje.getFullYear() - nascimento.getFullYear();
            let m = hoje.getMonth() - nascimento.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
                idade--;
            }

            // Verifica se o paciente faz aniversário no mês atual
            let fazAniversarioNoMesAtual = hoje.getMonth() === nascimento.getMonth();

            // Pega o dia de aniversário
            let diaAniversario = nascimento.getDate();

            // Pegar o mes de aniversário
            let mesAniversario = nascimento.getMonth();

            return {
                idade,
                fazAniversarioNoMesAtual,
                diaAniversario,
                mesAniversario
            };
        },
        chamadaNaoAtendida() {
            //ok
            medicoService.medico
                .chamadaNaoAtendida(this.ficha.idAtendimento)
                .then(rsp => {
                    console.log("rsp chamadaNaoAtendida:", rsp);
                    if (rsp.data) {
                        var fichaAux = JSON.parse(JSON.stringify(this.ficha));
                        this.adicionarListaPendente(fichaAux);
                        this.nChamada = 0;
                        this.habilitarBotaoCronometro = false;
                        this.textCronometroRegressivo = "[00:40]";
                        this.show = false;
                        clearInterval(this.intervalContagemRegressiva);
                        this.intervalContagemRegressiva = "";
                        //this.isPendentes = false;
                        this.dialogNaoCompareceu = false;
                        this.fezChamada = false;
                        this.ficha.codigo = "";
                        this.addedFicha = false;
                        this.ficha.nomeEspecialidade = "";
                        this.ficha.nomePaciente = "";
                        this.exibirListaPendentes();
                    }
                })
                .catch(err => {
                    // handle your error here
                    alert("ocorreu um erro !!");
                });
        },

        dialogLogout() {
            if (
                this.listaPacientesEspera.length > 0 ||
                this.listaPacientesPendente.length > 0
            ) {
                this.dialogConfirmarSaida = true;
            } else {
                this.logout();
            }
        },

        liberarPacientes() {
            // aqui faço a logica
            var idAtendimentos = this.listaPacientesPendente.reduce(
                (ids, atendimento) => {
                    if (atendimento.status == 4) {
                        ids.push(atendimento.idAtendimento);
                    }
                    return ids;
                },
                []
            );

            medicoService.medico
                .liberarPacientes(idAtendimentos)
                .then(rsp => {
                    console.log("rsp liberarPacientes:", rsp);
                    this.logout();
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        logout() {
            console.log("em logout..");
            //this.$router.push("/login");
            this.$store
                .dispatch("FedLogOut")
                .then(rsp => {
                    this.limparIntervalos();
                    this.socket ? this.socket.close() : "";
                    this.$router.push("/login");
                    if (r) { }
                })
                .catch(error => { });
        },

        groupBy(collection, property) {
            var i = 0,
                val,
                index,
                values = [],
                result = [];
            for (; i < collection.length; i++) {
                val = collection[i][property];
                index = values.indexOf(val);
                if (index > -1) result[index].push(collection[i]);
                else {
                    values.push(val);
                    result.push([collection[i]]);
                }
            }
            return result;
        },

        nomeFormatado(str) {
            var arr = str.split(" ");
            if (arr[1] != null) {
                var preposicao = arr[1].toLowerCase();
                if (
                    preposicao == "de" ||
                    preposicao == "da" ||
                    preposicao == "das" ||
                    preposicao == "do" ||
                    preposicao == "dos"
                ) {
                    preposicao = true;
                } else {
                    preposicao = false;
                }
            }
            return arr.slice(0, preposicao ? 3 : 2).join(" ");
        },

        modificarRules() {
            const rule = v =>
                (v && v.length <= 5) || "Mínimo 1 e máximo 5 caracteres";
            //this.nomeConsultorioRules = []
            this.nomeConsultorioRules.push(rule);
        },
        validateField() {
            this.rulesLocal = [];
            if (this.descricaoLocal.descricao === "Consultório ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v =>
                    (v && v.length <= 5) || "Mínimo 1 e máximo 5 caracteres";
                this.rulesLocal.push(rule1, rule2);
            } else if (this.descricaoLocal.descricao === "Outros ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v =>
                    (v && v.length <= 20) || "Mínimo 1 e máximo 20 caracteres";
                this.rulesLocal.push(rule1, rule2);
            } else if (this.descricaoLocal.descricao === "Laboratório ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v => v.length <= 5 || "Máximo 5 caracteres";
                this.rulesLocal.push(rule1, rule2);
            } else if (this.descricaoLocal.descricao === "Sala ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v =>
                    (v && v.length <= 5) || "Mínimo 1 e máximo 5 caracteres";
                this.rulesLocal.push(rule1, rule2);
            }
            this.$nextTick(() => this.$refs.form.validate());
        }
    },

    mounted() {
        this.user = this.$store.getters.usuario;

        EventBus.$on('logout', (data) => {
            this.dialogLogout()
        })

        EventBus.$on('retornarHelp', (data) => {
            this.retornarHelp()
        })

        EventBus.$on('mostrarTelaPrincipal', (data) => {
            this.addNew = false
            this.listaServicosDisponibilidade = this.user.ServicosDisponibilidade
            this.listaServicosSelecionados = this.user.nomeConsultorioServicos.servicos
            this.listaServicosEscolhidos = this.user.servicosEscolhidos
            this.localEscolhido = this.user.localEscolhido
            this.nomeConsultorio = this.user.nomeConsultorioServicos.nomeConsultorio
            this.nomeConsultorioCompleto = this.user.nomeConsultorioServicos.nomeConsultorio
            this.mostrarTelaPrincipal = false
            //this.adicionarServicos(false)
             //this.verificarLocalAutomatico(this.localEscolhido.idLocal)
        })

        this.listarCredenciaisAtendimento()

        if (this.user.tipo != 4 && this.user.tipo != 8) {
            this.$router.push("/login");
            return;
        }
        if (this.user.nomeConsultorioServicos) {
            this.socket = io.connect(socketService.SOCKET_URL, {
                query: {
                    token: getToken()
                }
            })
            console.log('token socket: ', this.getToken)
            
            this.chamarSocket();
            this.listaServicosDisponibilidade = this.user.ServicosDisponibilidade
            this.listaServicosSelecionados = this.user.nomeConsultorioServicos.servicos
            this.listaServicosEscolhidos = this.user.servicosEscolhidos
            this.localEscolhido = this.user.localEscolhido
            this.nomeConsultorio = this.user.nomeConsultorioServicos.nomeConsultorio
            this.nomeConsultorioCompleto = this.user.nomeConsultorioServicos.nomeConsultorio
            this.adicionarServicos(false)
            this.verificarLocalAutomatico(this.localEscolhido.idLocal)
            this.mostrarTelaPrincipal = true
        } else {
            this.retornarServicosDoMedico()
            //this.validateField();
        }

        this.retornarConsultasFinalizadas()
    },

    beforeDestroy: function () {
        EventBus.$off('logout')
        EventBus.$off('retornarHelp')
        EventBus.$off('showSideBar')
        EventBus.$off('mostrarTelaPrincipal')
        this.limparIntervalos()
        //this.offline();
    },

    created() {
        this.user = this.$store.getters.usuario;
    },
    watch: {
        listaPacientesDisponiveis: function (val) {
            // console.log('fdsfyui')
            this.qtdChamadasPrioridade = 0
            val.forEach(element => {
                if (element.prioridade == 1 || element.prioridade == 3) {
                    this.qtdChamadasPrioridade += 1
                }
            });

            this.listaPacientesDisponiveisFiltrada = this.listaPacientesDisponiveis.filter(item => {
                if (!this.searchDisponiveis) {
                    return this.listaPacientesDisponiveis;
                }
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchDisponiveis.toLowerCase());
            });
        },
        listaPacientesPendente: function (val) {
            // console.log('fdsfyui')
            this.qtdChamadasPrioridade = 0
            val.forEach(element => {
                if (element.prioridade == 1 || element.prioridade == 3) {
                    this.qtdChamadasPrioridade += 1
                }
            });

            this.listaPacientesPendenteFiltrada = this.listaPacientesPendente.filter(item => {
                if (!this.searchPendentes) {
                    return this.listaPacientesPendente;
                }
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchPendentes.toLowerCase());
            });
        },

        listaPacientes: function (val) {
            // console.log('fdsfyui')
            this.qtdChamadasPrioridade = 0
            val.forEach(element => {
                if (element.prioridade == 1 || element.prioridade == 3) {
                    this.qtdChamadasPrioridade += 1
                }
            });

            this.listaPacientesEsperaFiltrada = this.listaPacientesEspera.filter(item => {
                if (!this.searchEspera) {
                    return this.listaPacientesEspera;
                }
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchEspera.toLowerCase());
            });
        },
        searchDisponiveis() {
            this.listaPacientesDisponiveisFiltrada = this.listaPacientesDisponiveis.filter(item => {
                if (!this.searchDisponiveis) return this.listaPacientesDisponiveis;
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchDisponiveis.toLowerCase());
            });
        },
        searchPendentes() {
            this.listaPacientesPendenteFiltrada = this.listaPacientesPendente.filter(item => {
                if (!this.searchPendentes) return this.listaPacientesPendente;
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchPendentes.toLowerCase());
            });
        },
        searchEspera() {
            this.listaPacientesEsperaFiltrada = this.listaPacientesEspera.filter(item => {
                if (!this.searchEspera) return this.listaPacientesEspera;
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchEspera.toLowerCase());
            });
        },
        searchAtendidos() {
            this.listaPacientesAtendidosFiltrada = this.listaPacientesAtendidos.filter(item => {
                if (!this.searchAtendidos) return this.listaPacientesAtendidos;
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchAtendidos.toLowerCase());
            });
        }
    }
};
</script>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.selected-card {
    background-color: #e3f2fd;
    border-left: 4px solid #1976d2;
    transition: background-color 0.3s ease, border-color 0.3s ease;
}

.v-list-item {
    cursor: pointer;
}

#mybutton2 {
    position: fixed;
    bottom: 60px;
    right: 180px;
}

#fade {
    animation: bounce;
    /* referring directly to the animation's @keyframe declaration */
    animation-duration: 2s;
    /* don't forget to set a duration! */
}

.tile {
    margin: 0px;
    border-radius: 3px;
    background: rgb(167, 160, 160);
}

.rounded-card {
    border-radius: 50px;
}

.dialog {
    overflow-x: hidden;
}

.mensagemInicial {
    font-family: "Merriweather", serif;
    font-size: 21px;
}

.bg-white {
    background-color: white;
}
</style>
